// Chapter 5 of the detective game: "임계" (see Detective.js).
// Everything the player reads lives here; Detective.js only knows how to play it.

const n = (text) => ({ who: 'narr', text });
const me = (text) => ({ who: 'me', text });
const say = (who, text) => ({ who, text });

export const META = {
  id: 'ch5',
  number: 5,
  hanja: '臨界',
  name: '임계',
  subtitle: '12월 11일',
  tagline: '넘으면 돌아올 수 없는 점이 있다.',
  saveKey: 'detective_progress_ch5',
  startLoc: 'hq',
  // The in-game clock runs on clues found, in minutes from the first Monday's midnight.
  clock: {
    start: 960,
    end: 4740,
    days: ['12월 8일', '12월 9일', '12월 10일', '12월 11일'],
    limit: '12월 11일 저녁이 오기 전에',
  },
};

export const SPEAKERS = {
  me: { name: '서지안', title: '형사', tone: 'me' },
  moon: { name: '문 대장', title: '수사본부장', tone: 'gray' },
  kwak: { name: '곽 경사', title: '광역수사대', tone: 'orange' },
  eunho: { name: '윤은호', title: '국과수 연구관', tone: 'blue' },
  siho: { name: '윤시호', title: '소방 설비 기사', tone: 'violet' },
  tech: { name: '마 기사', title: '하청 기사', tone: 'violet' },
  song: { name: '송영만', title: '유족회 대표', tone: 'amber' },
  byun: { name: '변재만', title: '한성그룹 회장', tone: 'red' },
  ahn: { name: '안 연구사', title: '국과수', tone: 'rose' },
  keeper: { name: '오 주임', title: '납골당 관리', tone: 'green' },
  ha: { name: '하 센터장', title: '인천 신물류센터', tone: 'gray' },
  chae: { name: '채 과장', title: '한성 총무팀', tone: 'amber' },
  eom: { name: '엄 팀장', title: '본사 방재팀', tone: 'green' },
  light: { name: '도 기사', title: '조명 하청', tone: 'rose' },
  uncle: { name: '윤태수', title: '형제의 삼촌', tone: 'green' },
};

export const CLUES = {
  letter: {
    name: '동생의 편지',
    kind: '물증',
    text: '국과수 우편함에 뜯기지 않은 채 꽂혀 있던 봉투. 받는 사람은 윤은호. 네 현장의 메모와 같은 글씨다. 「형. 올해 납골당은 형이 가. 나는 못 가. / 12 · 11 / 6 · 8 · 8 / 찾지 마. / 39 · 92 · 7 · 14 · 67」 소인은 12월 5일, 서울.',
  },
  decoded: {
    name: '숫자로 쓴 세 줄',
    kind: '물증',
    text: '형제가 어릴 때 쓰던 방식이다. 원자 번호로 글자를 쓴다. 12 · 11은 12월 11일. 6 · 8 · 8은 C·O·O, 이산화탄소. 39 · 92 · 7 · 14 · 67은 Y·U·N·Si·Ho, 윤시호.',
  },
  yun: {
    name: '모니터의 메모지',
    kind: '물증',
    text: '네 현장의 전선마다 붙어 있던 39-92-7은 품번이 아니다. Y·U·N, 윤. 그 기사는 전선마다 제 성을 붙였다. 윤은호는 4월에 그 라벨을 봤고, 읽을 줄 알았다.',
  },
  searchOrder: {
    name: '소재 수사 지시서',
    kind: '물증',
    text: '수사본부가 윤은호를 동생과 한패로 보고 찾는 근거. 한성물류 화재 유족. 부산 화재를 직접 조사해 사고로 결론. 4월에 전선의 숫자를 읽고도 알리지 않음. 8월부터 휴직, 넉 달째 연락 두절. 범인이 날짜와 수단을 적어 보낸 편지를 받는 사람.',
  },
  schedule: {
    name: '12월 11일의 일정',
    kind: '물증',
    text: '그날 변재만 회장이 가는 곳은 둘. 오전 10시 인천 신물류센터 준공식, 저녁 7시 본사 지하 2층 컨벤션홀의 창립 30주년 기념식.',
  },
  cctv: {
    name: '지하 3층의 윤은호',
    kind: '물증',
    text: '12월 9일 23시 12분, 한성 본사 지하 3층 CCTV. 작업 조끼 차림의 윤은호가 가스 저장실 문 앞에 4분간 서 있다가 돌아간다. 문은 열리지 않았다.',
  },
  leave: {
    name: '휴직계',
    kind: '물증',
    text: '8월 1일 자. 사유는 「가족 사정」 네 글자. 그의 책상 달력에는 거의 토요일마다 동그라미가 쳐져 있고, 동그라미는 4월 5일에서 끝난다.',
  },
  trail: {
    name: '그가 찾던 것',
    kind: '증언',
    text: '안 연구사의 말. 윤은호는 4월부터 지난 4년 사이 폐업한 소방 유지보수 업체 서른 곳의 명단을 모았다. 휴직 전에 마지막으로 가져간 자료는 한성그룹 건물들의 소방 설비 현황과 이산화탄소 소화설비 사고 조사집. 「내가 먼저 찾아야 하는 사람」이 있다고 했다.',
  },
  co2Fact: {
    name: '불을 끄는 가스',
    kind: '증언',
    text: '안 연구사의 설명. 이산화탄소 소화설비는 방을 가스로 채워 산소를 밀어내고 불을 끈다. 그 방의 사람은 몇 번 숨에 정신을 잃는다. 가스는 공기보다 1.5배쯤 무거워 낮은 곳에 고인다. 하얗게 보이는 것은 김이고 가스 자체는 보이지 않는다. 이 설비가 있는 건물은 공기호흡기를 갖춰 둬야 한다.',
  },
  handMatch: {
    name: '필적 대조 결과',
    kind: '물증',
    text: '문서 분석실 회신. 편지와 봉투, 네 현장의 메모는 같은 사람의 글씨일 가능성이 매우 높다. 네 현장에 메모를 남긴 기사가 윤은호를 「형」이라고 불렀다.',
  },
  petition: {
    name: '탄원서 묶음',
    kind: '물증',
    text: '2012년 재판 때 법원에 낸 「변재만 선처 탄원서」 사본. 한성 임직원과 협력사 1,043명의 서명. 판결문은 이것을 참작한다고 썼다.',
  },
  younger: {
    name: '작은아들 시호',
    kind: '증언',
    text: '송영만의 말. 윤 선생의 작은아들 이름은 시호. 재판 날마다 교복을 입고 맨 앞줄에 혼자 앉았다. 선고 날 탄원서 묶음을 한 장씩 끝까지 넘겨 보고 물었다. 「이 사람들은 다 알았을까요. 잠가 놓은 거.」 그 뒤로 유족회에 오지 않았다.',
  },
  memorial: {
    name: '7시 42분',
    kind: '물증',
    text: '유족회는 해마다 12월 11일 저녁 7시 42분에 초 아홉 개를 켠다. 15년 전 119에 첫 신고가 들어간 시각이다. 올해가 15주기다.',
  },
  guestbook: {
    name: '납골당 방명록',
    kind: '물증',
    text: '윤태준·김연희의 자리 앞 방명록. 해마다 12월 10일에 꾹꾹 눌러 쓴 같은 글씨가 있다. 서명은 「시호」. 15년 동안 한 해도 거르지 않았다. 올해 것은 없다.',
  },
  brotherNote: {
    name: '형이 남긴 줄',
    kind: '물증',
    text: '방명록의 올해 장에는 다른 글씨가 있다. 8월부터 다섯 번. 마지막은 12월 7일. 「시호야. 전화 받아라. 어디든 갈게. 형.」 답은 한 줄도 없다.',
  },
  noRecord: {
    name: '서류에 없는 사람',
    kind: '물증',
    text: '윤시호, 30세. 2021년 11월 주민등록이 거주 불명으로 처리됐다. 그 뒤로 그의 이름으로는 휴대폰도, 계좌 거래도, 병원 기록도 없다. 남은 것은 2016년에 딴 소방설비 자격증과, 2021년까지 여러 소방서에 그의 이름으로 들어간 신고 스물세 건.',
  },
  incheonClean: {
    name: '꺼진 것이 없는 곳',
    kind: '물증',
    text: '인천 신물류센터의 점검표. 스프링클러 열림, 경보 정상, 비상구 열림. 지적 사항 0건. 기사의 메모도 없다. 방을 이산화탄소로 채우는 설비도 없다.',
  },
  invitation: {
    name: '기념식 안내문',
    kind: '물증',
    text: '한성그룹 창립 30주년 기념식. 12월 11일 저녁 7시, 본사 지하 2층 컨벤션홀. 초청 대상은 근속 20년이 넘은 임직원과 창립 때부터의 협력사 천 명. 「어려울 때 한성의 곁을 지켜 주신 분들」. 7시 40분 회장 건배사.',
  },
  byunSays: {
    name: '회장의 대답',
    kind: '증언',
    text: '12월 11일이 무슨 날이냐고 묻자 변재만은 「내 일정이 비는 목요일」이라고 답했다. 15년 전 그날 저녁 자기 물류센터에서 아홉 명이 죽었다는 것을 그는 떠올리지 못했다.',
  },
  guests: {
    name: '초대받은 사람들',
    kind: '증언',
    text: '채 과장의 말. 초청 명단은 회장이 직접 골랐다. 「어려울 때 회사 편에 서 준 분들」. 명단 원본에는 손글씨 메모가 있다. 「2012년 탄원 명부 참조」.',
  },
  gasSystem: {
    name: '천장의 분사구',
    kind: '물증',
    text: '컨벤션홀은 5년 전까지 그룹 전산센터였다. 천장 마감 뒤에 굵은 배관과 분사구 스물네 개가 남아 있다. 이산화탄소 소화설비다. 철거에 2억이 든다고 해서 그대로 두고 연회장을 만들었다.',
  },
  doors: {
    name: '네 개의 문',
    kind: '물증',
    text: '홀의 문은 넷. 행사 때는 정문만 열고 옆문 셋은 전자석으로 잠근다. 불이 나면 저절로 풀리게 하는 기능은 꺼 놨다. 문마다 옆에 초록색 비상 개방 상자가 있다. 덮개를 깨고 누르면 그 문의 전자석이 풀린다.',
  },
  cabinet: {
    name: '문 안쪽의 조작함',
    kind: '물증',
    text: '정문 안쪽, 커튼 뒤의 붉은 함. 옛날식 판유리 덮개 안에 단추가 둘 있다. 「수동 기동」과 「방출 지연」. 공사하며 벽을 옮기는 바람에 홀 밖에 있던 함이 홀 안에 남았다.',
  },
  delaySwitch: {
    name: '방출 지연 단추',
    kind: '증언',
    text: '마 기사의 설명. 경보가 울리고 30초 뒤에 가스가 나온다. 조작함의 방출 지연 단추는 누르고 있는 동안만 그 시계를 멈춘다. 손을 떼면 멈췄던 데서 다시 간다. 저장실의 제어반은 전부를 멈추고, 저장실의 수동 레버는 시계를 건너뛰어 바로 내보낸다.',
  },
  ducts: {
    name: '뚫린 벽',
    kind: '증언',
    text: '엄 팀장의 말. 전산센터 때 그 방은 가스가 새지 않게 꽉 막혀 있었다. 연회장으로 고치며 냉난방 통로를 여섯 군데 뚫었다. 가스가 터지면 로비와 계단으로 샌다. 문을 닫으면 덜 샌다.',
  },
  fifthNote: {
    name: '다섯 번째 메모',
    kind: '물증',
    text: '본사 방재실의 9월 점검표. 「지하 2층 컨벤션홀은 옛 전산센터임. 이산화탄소 소화설비가 그대로 남아 있음. 사람이 모이는 곳에 둘 수 없는 설비임. 철거 요망. 관리자 서명 거부.」 네 현장의 메모와 같은 글씨다.',
  },
  maPaper: {
    name: '하청 인력 조회 결과',
    kind: '물증',
    text: '본사에 드나드는 하청 인력 여든세 명의 조회 결과. 소방 점검은 세이프텍 소속 마동수, 52세, 소방설비기사. 범죄 경력 없음, 주소지 확인. 부천 집의 가족은 그가 한성 본사 현장에 나가 있다고 했다. 서류에 걸리는 사람은 없다.',
  },
  basement: {
    name: '지하 3층',
    kind: '물증',
    text: '본사 지하 3층. 계단문 옆 벽에 「주차장·기계실 배기팬」과 「경사로 셔터」 단추, 그리고 소화전함이 있다. 가스 저장실은 거기서 열 단을 더 내려간 기계실 복도에 있다. 건물에서 제일 낮은 자리다. 계단 밑에서 저장실 문까지 여덟 걸음. 문 옆 함의 공기호흡기는 한 벌뿐이고 마지막 점검은 2023년 6월이다.',
  },
  rescueRule: {
    name: '그가 가르친 순서',
    kind: '기억',
    text: '4월에 윤은호가 한 말. 들어가지 말 것. 가스를 잠그고 바람부터 넣을 것. 꼭 들어가야 하면 공기통을 메고, 밖에서 줄을 잡아 줄 사람을 둘 것.',
  },
  fridge: {
    name: '냉장고의 쪽지',
    kind: '물증',
    text: '윤은호의 집 냉장고에 붙은 쪽지 두 장. 「11 · 31」은 Na·Ga, 나가. 「28 · 31 · 31」은 Ni·Ga·Ga, 니가 가. 어린 윤시호가 제 방문에 붙인 것과 윤은호의 답장이다. 화학 교사였던 아버지가 두 아들에게 가르친 대로 원자 번호로 썼다.',
  },
  room: {
    name: '비워 둔 방',
    kind: '물증',
    text: '윤은호의 집 현관 옆 작은방. 침대와 책상, 빈 옷장. 책상 위에 「시호」라는 이름표가 달린 현관 열쇠가 있다. 이사를 네 번 하는 동안 네 번 다 이 방을 만들었다. 이 방에서 잔 사람은 없다.',
  },
  tracing: {
    name: '벽의 업체 서른 곳',
    kind: '물증',
    text: '윤은호의 집 거실 벽. 지난 4년 사이 폐업한 소방 유지보수 업체 서른 곳. 4월 19일부터 7월 27일까지 주말마다 한 곳씩 찾아가 열한 곳에 줄을 그었다. 나머지 열아홉 곳은 8월에 들고 나갔다.',
  },
  reports: {
    name: '스물세 번의 신고',
    kind: '물증',
    text: '윤은호가 모은 서류철 「시호. 2014–2021」. 윤시호는 7년 동안 꺼진 장치를 볼 때마다 적고, 관리자의 서명을 청하고, 소방서에 신고했다. 스물세 번. 처벌받은 사람은 없다. 윤시호는 세 번 해고됐다.',
  },
  judgment: {
    name: '2021년의 판결문',
    kind: '물증',
    text: '2021년 1월, 윤시호는 평택의 냉동 창고에 「화재 경보 차단. 복구 요망. 관리자 서명 거부.」라고 적고 신고했다. 3주 뒤 그 창고에 불이 나 스물한 살 아르바이트생이 죽었다. 그 창고에 「양호」를 찍어 준 점검업체 대표는 표영달이다. 10월 28일, 집행유예. 그날 윤시호는 휴대폰과 계좌를 끊고 고시원을 나갔다.',
  },
  unsent: {
    name: '부치지 않은 편지',
    kind: '물증',
    text: '7월 31일 자. 윤은호가 서지안에게 쓰고 부치지 않았다. 4월에 숫자를 보고 알았다. 말하면 총을 든 사람들이 동생 앞에 설 것이다. 중학교 3학년짜리를 두고 간 사람이 자기니까 데려오는 것도 자기가 해야 한다. 부끄럽다.',
  },
  leftBehind: {
    name: '두고 간 겨울',
    kind: '증언',
    text: '삼촌 윤태수의 말. 2011년 2월, 대학에 붙은 윤은호는 서울로 갔고 중학교를 막 졸업한 윤시호는 서해의 삼촌 집에 남았다. 윤은호는 안 간다고 했고 삼촌이 보냈다. 윤시호는 터미널에 나오지 않았다. 재판에는 혼자 다녔다.',
  },
  parcel: {
    name: '삼촌에게 온 봉투',
    kind: '물증',
    text: '소인은 12월 5일, 서울. 보내는 사람 없음. 5만 원권 묶음과 쪽지 한 장. 「삼촌. 6년 치 밥값입니다. 고마웠습니다. 시호.」 형에게 편지를 부친 날 같이 부쳤다.',
  },
};

export const INTRO = [
  n('12월 8일 월요일, 아침 아홉 시. 국립과학수사연구원.'),
  n('음성의 탱크에서 남기찬이 죽고 여덟 달이 지났다. 「한성물류 화재 연쇄 사건 수사본부」는 네 현장에 메모를 남긴 기사의 이름을 아직 모른다.'),
  n('윤은호의 마지막 메시지는 6월 말이다. 「조금만 더요. 미안해요.」 8월 1일에 휴직했고, 그달부터 전화기가 꺼져 있다. 나한테는 말하지 않았다. 얼굴을 본 것은 4월이 마지막이다.'),
  n('분석 결과를 받으러 국과수에 올 때마다 2층 복도 벽에 있는 그의 우편함을 본다. 넉 달 동안 학회지와 고지서뿐이었다.'),
  n('오늘은 흰 봉투가 하나 꽂혀 있다. 받는 사람은 「국립과학수사연구원 윤은호」. 보내는 사람 칸은 비어 있다. 볼펜으로 꾹꾹 눌러 쓴 글씨다. 종이 뒤로 자국이 배어 나왔다.'),
  n('나는 그 글씨를 안다. 홍천, 화성, 부산, 음성. 네 현장의 점검표에 「복구 요망. 관리자 서명 거부.」라고 적은 글씨다.'),
  n('봉투에 손을 대지 않았다. 남의 우편물이고 증거물이다. 문 대장에게 전화했다. 영장은 오후 두 시에 나왔다.'),
  n('오후 네 시, 수사본부. 장갑을 끼고 봉투를 열었다. 종이 한 장에 다섯 줄이 적혀 있다.'),
  n('「형. 올해 납골당은 형이 가. 나는 못 가.」'),
  n('「12 · 11」'),
  n('「6 · 8 · 8」'),
  n('「찾지 마.」'),
  n('「39 · 92 · 7 · 14 · 67」'),
  say('kwak', '…형? 그 기사가 윤 연구관을 형이라고 불러?'),
  me('동생이 있다고 했어요. 소방 설비 일을 한다고요. 이름은 시호예요.'),
  n('작년 12월에 들은 말이다. 여덟 달 동안 나는 그 말과 네 현장의 기사를 한 번도 나란히 놓아 보지 않았다.'),
  n('곽 경사는 더 묻지 않았다. 나는 종이에서 눈을 떼지 못했다.'),
  say('moon', '한글로 쓴 줄은 누구나 읽어. 숫자로 쓴 줄은 형만 읽으라는 거겠지. 12 · 11은 날짜일 거야. 사흘 남았어. 나머지가 뭔지 그 전에 알아내.'),
  say('sys', '편지를 읽고, 사람들을 만나고, 단서를 모으세요. 준비가 되면 [추리하기]로 문 대장에게 보고합니다.'),
];

export const LOCATIONS = [
  {
    id: 'hq',
    name: '수사본부',
    desc: '지방청 별관 3층, 광역수사대. 수사본부 현판이 붙은 지 여덟 달째다. 벽의 지도에는 붉은 핀이 넷. 홍천, 화성, 부산, 음성. 내 모니터 귀퉁이에는 메모지 한 장이 여덟 달째 붙어 있다. 39-92-7.',
    hotspots: [
      {
        id: 'letter',
        label: '편지를 다시 읽는다',
        variants: [
          {
            lines: [
              n('증거물 봉투에 넣은 편지를 책상 등 밑에 놓았다.'),
              n('종이는 소방 점검표 용지다. 앞면의 「점검 일자」 「지적 사항」 「관리자 확인」 칸은 전부 비어 있다. 그는 그 뒷면에 썼다.'),
              n('한글로 쓴 줄은 둘이다. 「형. 올해 납골당은 형이 가. 나는 못 가.」 그리고 「찾지 마.」'),
              n('작년 12월, 과학관 옥상에서 윤은호의 휴대폰에 뜬 문자가 있었다. 「형. 올해도 납골당은 나 혼자 다녀왔어.」 해마다 혼자 가던 사람이 올해는 못 간다고 썼다.'),
              n('나머지 세 줄은 숫자다. 숫자 사이마다 가운뎃점이 찍혀 있다.'),
              n('이렇게 쓴 숫자를 본 적이 있다. 2월에 처음 간 윤은호의 집 냉장고다. 누렇게 바랜 쪽지 두 장이 자석에 물려 있었다. 「11 · 31」, 그리고 그 밑에 「28 · 31 · 31」.'),
              n('윤은호는 웃으면서 일러 줬다. 위의 것은 동생이 어릴 때 제 방문에 붙여 놓은 것이라고 했다. 11번은 나트륨 Na, 31번은 갈륨 Ga. 나가.'),
              n('밑의 것은 자기가 써 붙인 답장이라고 했다. 28번 니켈 Ni, 그리고 31, 31. 니가 가.'),
              n('화학 교사였던 아버지가 두 아들에게 가르친 것이다. 원자 번호로 글자를 쓴다. 그 집 식구가 아니면 읽지 못한다.'),
              n('봉투의 소인은 12월 5일, 서울. 형의 집이 아니라 직장으로 보냈다. 형이 넉 달째 그곳에 나오지 않는다는 것을 동생은 모른다.'),
            ],
            gives: ['letter'],
          },
        ],
      },
      {
        id: 'decode',
        label: '주기율표를 띄우고 숫자를 읽는다',
        showWhen: { clue: 'letter' },
        variants: [
          {
            lines: [
              n('주기율표를 화면에 띄웠다. 수첩을 펴고 한 줄씩 옮겨 적었다.'),
              n('「12 · 11」. 12번은 마그네슘 Mg, 11번은 나트륨 Na. 이어 붙여도 말이 되지 않는다. 이 줄은 숫자 그대로다. 12월 11일. 15년 전 한성물류센터에 불이 난 날이고, 사흘 뒤다.'),
              n('「6 · 8 · 8」. 6번은 탄소 C. 8번은 산소 O. 다시 8번, 산소 O.'),
              n('C, O, O. 탄소 하나에 산소 둘. 이산화탄소다.'),
              n('마지막 줄. 「39 · 92 · 7 · 14 · 67」. 편지 맨 끝, 이름을 쓰는 자리다.'),
              n('39번은 이트륨 Y. 92번은 우라늄 U. 7번은 질소 N.'),
              n('14번은 규소 Si. 67번은 홀뮴 Ho.'),
              n('Y, U, N, Si, Ho.'),
              n('윤시호.'),
              n('12월 11일, 이산화탄소, 윤시호. 날짜와 수단과 이름이다. 그는 그것을 형에게만 알렸다.'),
              say('kwak', '풀었어? 뭐래.'),
              me('…날짜하고 가스 이름이에요. 그리고 맨 끝은 서명이에요. 윤시호.'),
            ],
            gives: ['decoded'],
          },
        ],
      },
      {
        id: 'monitor',
        label: '모니터에 붙은 메모지를 본다',
        showWhen: { clue: 'decoded' },
        variants: [
          {
            lines: [
              n('수첩에서 눈을 들었다. 모니터 귀퉁이에 메모지 한 장이 붙어 있다. 4월에 내가 써 붙인 것이다. 39-92-7.'),
              n('네 현장에서 안전장치를 건너뛰게 이어 놓은 전선마다 흰 라벨이 붙어 있었고, 라벨마다 이 숫자가 있었다. 여덟 달 동안 품번 대장을 뒤졌다. 어느 제조사에도 없는 번호였다.'),
              n('방금 수첩에 적은 줄의 앞머리와 같다. 39, 92, 7.'),
              n('Y, U, N.'),
              n('윤.'),
              n('품번이 아니었다. 그 기사는 제가 단 전선마다 제 성을 붙여 놓았다. 홍천에도, 화성에도, 부산에도, 음성에도.'),
              n('4월, 국과수 실험실. 윤은호가 부산 창고에서 나온 그을린 전선을 뒤집었다. 반쯤 녹은 라벨의 숫자를 소리 내어 읽었다. 「39, 92, 7.」'),
              n('읽고 나서 윤은호는 그대로 멈췄다. 전선을 든 손이 내려오지 않았다. 얼굴에서 핏기가 빠졌다. 「제가 놓쳤습니다.」'),
              n('넉 달 전에 놓친 것을 이제야 본 사람의 얼굴이라고, 그때 나는 생각했다.'),
              n('아니었다. 윤은호는 이 숫자를 읽을 줄 안다. 어릴 적 쪽지를 여태 냉장고에 붙여 두고 사는 사람이다.'),
              n('그 주에 세 현장의 메모를 보여 줬을 때, 윤은호는 서명 위에서 손끝을 멈추고 말했다. 「…시간을 좀 주세요. 확인해 볼 데가 있습니다.」'),
              n('윤은호는 알았다. 나는 두 번 다 바로 옆에 있었다. 윤은호는 말하지 않았다.'),
              n('휴대폰을 들어 그의 번호를 눌렀다. 「전원이 꺼져 있어 삐 소리 후…」 넉 달째 같은 안내다. 끝까지 듣고 끊었다.'),
            ],
            gives: ['yun'],
          },
        ],
      },
      {
        id: 'searchFile',
        label: '소재 수사 지시서를 읽는다',
        showWhen: { flag: 'search' },
        variants: [
          {
            lines: [
              n('문 대장이 한 시간 만에 돌린 문서. 제목은 「윤은호(33) 소재 수사 지시」다. 어디 있는지 찾아내라는 지시다.'),
              n('「하나. 2010년 한성물류센터 화재로 부모를 잃은 유족임.」'),
              n('「둘. 2024년 11월 부산 화재를 직접 조사해 사고로 결론 냄.」'),
              n('「셋. 2025년 4월, 범인이 전선에 남긴 숫자 39-92-7을 보고 그 뜻을 알았으나 수사본부에 알리지 않음.」'),
              n('「넷. 8월 1일 자로 휴직. 이후 휴대폰 전원이 꺼져 있고 주소지에 없음.」'),
              n('「다섯. 범인 윤시호의 친형이며, 범인이 범행 날짜와 수단을 적어 보낸 편지를 받는 사람임.」'),
              n('한 줄 한 줄이 사실이다. 지어낸 것은 하나도 없다.'),
              n('맨 아래에 한 줄이 더 있다. 「수사본부 서지안 경위와 교제 중인 것으로 알려짐. 연락이 닿으면 즉시 보고하도록 함.」'),
            ],
            gives: ['searchOrder'],
          },
        ],
      },
      {
        id: 'schedule',
        label: '12월 11일에 무엇이 있는지 찾는다',
        showWhen: { clue: 'yun' },
        variants: [
          {
            lines: [
              n('재판받은 다섯 명 가운데 살아 있는 사람은 변재만 회장 하나다. 12월 11일에 그가 어디에 있는지부터 봤다.'),
              n('한성그룹 홍보실에서 받은 일정표. 그날 회장의 공개 일정은 둘이다.'),
              n('「오전 10시. 인천 신물류센터 준공식. 기자단 60명 초청.」'),
              n('「저녁 7시. 창립 30주년 기념식. 본사 지하 2층 컨벤션홀. 임직원 및 협력사 1,000명.」'),
              n('6월에서 가을로, 가을에서 연말로 두 번 미뤄진 그 기념식이다.'),
              say('kwak', '물류센터 아니면 지하 연회장. 둘 중 하나네.'),
              say('kwak', '대장은 인천으로 볼걸. 15년 전에 탄 게 물류센터니까. 이산화탄소도 불이 나면 나오는 가스고.'),
              n('두 군데 다 가 봐야 한다.'),
            ],
            gives: ['schedule'],
          },
        ],
      },
      {
        id: 'cctv',
        label: '한성 본사의 CCTV 영상을 본다',
        showWhen: { flag: 'sighting' },
        variants: [
          {
            lines: [
              n('수사본부는 편지를 연 월요일부터 한성의 두 건물 CCTV를 넘겨받아 보고 있다. 문 대장이 표시해 둔 구간을 틀었다.'),
              n('12월 9일 23시 12분. 한성 본사 지하 3층, 기계실 복도.'),
              n('작업 조끼를 입은 남자가 걸어 들어온다. 모자는 쓰지 않았다. 카메라를 피하지도 않는다. 윤은호다. 여덟 달 만에 보는 얼굴이 많이 말랐다.'),
              n('윤은호는 「가스 저장실」이라고 적힌 철문 앞에 선다. 손잡이를 돌려 본다. 열리지 않는다. 카드를 대는 자리에 무언가를 대 본다. 열리지 않는다.'),
              n('윤은호는 문에 이마를 대고 4분을 서 있다가 돌아간다. 23시 16분.'),
              n('문 대장은 이 구간에 「본사 사전 답사. 저장실에 들어가지 못함」이라고 적어 놓았다. 내 눈에는 잠긴 문 앞에서 돌아선 사람으로 보인다. 하지만 그것은 내 눈에 그렇게 보인다는 것뿐이다.'),
            ],
            gives: ['cctv'],
          },
        ],
      },
      {
        id: 'registry',
        label: '윤시호라는 이름을 조회한다',
        showWhen: { clue: 'decoded' },
        variants: [
          {
            lines: [
              n('윤시호. 1995년생, 서른 살. 주민등록을 조회했다.'),
              n('「거주 불명 등록. 2021년 11월.」 살던 고시원에서 말없이 나간 뒤 주소를 옮기지 않았다는 뜻이다.'),
              n('그 뒤 4년 동안 그의 이름으로 된 휴대폰이 없다. 계좌 거래가 없다. 병원에 간 기록도 없다. 한 번도 안 갔거나, 다른 이름으로 갔다.'),
              n('남은 기록은 둘이다. 2016년에 딴 소방설비 자격증. 스물한 살 때다. 그리고 2021년까지 여러 소방서에 그의 이름으로 들어간 신고가 스물세 건 있다. 무슨 신고인지는 조회 화면에 나오지 않는다.'),
              n('사진은 그 자격증에 붙은 증명사진이 마지막이다. 9년 전 얼굴이다.'),
              say('kwak', '서류로는 4년 전에 증발한 사람이네. 그래서 여덟 달을 뒤져도 이름이 안 나왔구먼.'),
              say('kwak', '봄에 업체들에 전화 돌렸을 때 기억나? 그 기사는 늘 하청의 하청으로 들어왔고, 서류에 적힌 자격증 번호의 주인은 현장에 와 본 적도 없었어. 서류에 없이 일하는 법을 아는 놈이야.'),
            ],
            gives: ['noRecord'],
          },
        ],
      },
      {
        id: 'maCheck',
        label: '본사 하청 인력의 신원을 조회한다',
        showWhen: [{ clue: 'fifthNote' }, { flag: 'askedOut' }],
        variants: [
          {
            lines: [
              n('다섯 번째 메모가 나온 건물이다. 엄 팀장에게 받은 마 기사의 출입 등록 서류, 그리고 총무팀이 뽑아 준 하청 출입 대장을 통째로 조회에 넣었다.'),
              n('출입 대장은 여든세 명이다. 무대, 조명, 음식, 청소, 소방 점검. 범죄 경력이 있는 사람은 둘이고 둘 다 음주 운전이다. 주소지가 맞지 않는 사람은 없다.'),
              n('소방 점검은 한 사람이다. 「마동수. 1973년생, 52세. 소방설비기사. 세이프텍 소속. 범죄 경력 없음. 주소지 경기 부천.」 세이프텍의 사업자 등록도 살아 있다. 한성 본사와 맺은 계약서에는 「투입 인력: 소방설비기사 1인」.'),
              n('9월까지 본사를 맡았던 업체도 조회했다. 10월 초에 폐업 신고를 했고 대표 전화는 없는 번호다. 다섯 번째 메모를 쓴 기사의 이름은 이번에도 서류에 남지 않았다.'),
              say('kwak', '봄에 본 수법이 마음에 걸려서 부천 집에 전화해 봤어. 자격증 주인은 현장에 안 나오는 그거 말이야. 부인이 받더라. 「남편요? 강남 한성 본사 현장에 나가 있어요.」'),
              say('kwak', '쉰둘에, 집도 맞고, 본인이 현장에 나가 있대. 조명 쪽 도 기사도 서른넷에 깨끗하고. 여든세 명을 다 봤으면 할 만큼 한 거야.'),
              n('서류도, 집도, 계약서도 맞는다. 여든세 명 가운데 걸리는 사람은 없다. 걸린다는 느낌만으로 사람을 붙잡아 둘 수는 없다. 나는 조회 결과를 철에 끼웠다.'),
            ],
            gives: ['maPaper'],
          },
        ],
      },
      {
        id: 'desk',
        label: '내 책상 서랍을 연다',
        variants: [
          {
            lines: [
              n('맨 위 서랍. 박 반장의 믹스커피 상자가 있다. 강력2팀에서 광역수사대로 올 때 이것부터 챙겼다. 유통기한은 지난 지 오래다.'),
              n('그 옆에 핫팩이 하나 있다. 지난겨울 윤은호가 한 상자를 사서 말도 없이 넣어 두고 갔다. 출장 갈 때마다 하나씩 썼고, 하나가 남았다. 이것은 뜯지 않았다.'),
              n('아래 서랍에는 씻어 둔 도시락통이 있다. 4월에 윤은호가 밤에 싸 들고 와서 수사대 복도에 40분을 서 있다가 맡기고 간 것이다. 나는 그것을 새벽 두 시에 식은 채로 먹었다. 통은 여덟 달째 돌려주지 못했다.'),
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'nfs',
    name: '국과수',
    desc: '국립과학수사연구원. 2층 복도 끝, 윤은호의 실험실은 불이 꺼져 있다. 복도 벽의 우편함 가운데 그의 칸만 넉 달째 차 있다. 옆방에서 그의 후배 안 연구사가 나와 문을 열어 줬다.',
    hotspots: [
      {
        id: 'door',
        label: '실험실 문의 이름표를 본다',
        variants: [
          {
            lines: [
              n('이름표 밑의 포스트잇은 아직 붙어 있다. 볕에 바래서 글씨가 흐리다. 「Y-U-N-Eu-N-Ho 박사님은 오늘도 야근」.'),
              n('후배들이 붙인 것이다. 윤은호는 떼지 않았다. 그런 것을 떼지 않는 사람이었다.'),
            ],
          },
        ],
      },
      {
        id: 'mailbox',
        label: '그의 우편함을 본다',
        variants: [
          {
            lines: [
              n('편지가 꽂혀 있던 칸이다. 남은 우편물을 꺼내 봤다.'),
              n('학회지 넉 달 치. 관리비 고지서. 자료실의 반납 독촉장이 석 장. 「이산화탄소 소화설비 사고 조사집. 7월 28일 대출. 미반납.」'),
              n('서해과학관에서 온 안내장도 있다. 「연간 회원(2인) 만료 예정. 2026년 1월.」'),
              n('우편함은 넉 달 동안 아무도 비우지 않았다. 동생의 편지는 이 사이에 꽂혀 있었다.'),
            ],
          },
        ],
      },
      {
        id: 'desk',
        label: '그의 책상을 본다',
        variants: [
          {
            lines: [
              n('책상은 비어 있다. 현미경에는 덮개가 씌워져 있고, 탁상 달력은 7월에서 멈췄다.'),
              n('서류꽂이에 휴직계 사본이 한 장 남아 있다. 8월 1일 자. 사유 칸에는 네 글자뿐이다. 「가족 사정」.'),
              n('달력을 앞으로 넘겼다. 1월부터 거의 토요일마다 작은 동그라미가 쳐져 있다. 과학관 옥상에 올라가던 날이다. 동그라미는 4월 5일에서 끝난다.'),
              n('4월 12일 칸에는 동그라미를 쳤다가 지운 자국이 있다. 그 토요일에 나는 음성에 있었다. 그다음 토요일부터는 자국도 없다.'),
            ],
            gives: ['leave'],
          },
        ],
      },
      {
        id: 'compare',
        label: '문서 분석실에 편지를 맡긴다',
        showWhen: { clue: 'letter' },
        variants: [
          {
            lines: [
              n('1층 문서 분석실. 지난봄 네 현장의 메모가 같은 글씨라고 답해 준 곳이다. 편지와 봉투를 맡겼다.'),
              n('회신. 「편지와 봉투, 현장 메모 네 건의 필적은 같은 사람의 것일 가능성이 매우 높음. ㅂ의 획 순서와 요의 기울기가 일치함. 눌러 쓰는 힘도 같음.」'),
              n('네 현장에 메모를 남긴 기사가 이 편지를 썼다. 눈으로 알아본 것이 이제 종이로 남았다.'),
            ],
            gives: ['handMatch'],
          },
        ],
      },
    ],
  },
  {
    id: 'bereaved',
    name: '유족회',
    desc: '서울 변두리 상가 2층. 「한성물류센터 화재 참사 유족회」. 벽의 영정 아홉 장 아래에 종이 상자가 나와 있다. 송영만은 오늘 피켓 대신 초를 닦고 있다.',
    hotspots: [
      {
        id: 'wall',
        label: '영정 아래의 상자를 본다',
        variants: [
          {
            lines: [
              n('상자 안에 굵은 흰 초가 아홉 개 들어 있다. 상자 옆면에 매직으로 적혀 있다. 「12/11 19:42」.'),
              n('송영만이 초를 닦던 손을 멈추지 않고 말했다.'),
              say('song', '15주기요. 해마다 그 시각에 켜오. 저녁 7시 42분. 119에 첫 신고가 들어간 시각이오.'),
              say('song', '집사람이 그날 7시에 야간 조로 들어갔소. 들어간 지 42분 만이었지.'),
              n('벽의 네 번째와 다섯 번째 사진을 봤다. 윤태준, 김연희. 한 액자에 든 부부다. 윤태준의 눈매는 볼 때마다 윤은호를 닮았다.'),
            ],
            gives: ['memorial'],
          },
        ],
      },
      {
        id: 'petition',
        label: '송영만이 꺼내 준 서류 묶음을 본다',
        showWhen: { clue: 'younger' },
        variants: [
          {
            lines: [
              n('송영만이 캐비닛 맨 아래 칸에서 누렇게 바랜 서류 묶음을 꺼내 줬다. 노끈으로 묶은 두께가 손 한 뼘이다.'),
              n('표지. 「피고인 변재만에 대한 선처 탄원서. 2012년 5월.」'),
              n('첫 장. 「존경하는 재판장님. 변재만 대표는 직원을 가족처럼 여겨 온 분입니다. 회사가 무너지면 저희 모두의 생계가 무너집니다. 부디 선처하여 주십시오.」'),
              n('그 아래로 이름과 서명이 이어진다. 한 장에 스무 명. 한성물류 임직원, 그리고 협력사 직원들. 맨 뒷장에 누가 연필로 적어 놓았다. 「총 1,043명」.'),
              say('song', '판사가 판결문에 그랬소. 「다수의 임직원이 선처를 탄원하는 점을 참작한다.」 아홉이 죽었는데 천 명이 그놈 편을 들었다고, 그걸 참작한다고.'),
            ],
            gives: ['petition'],
          },
        ],
      },
    ],
  },
  {
    id: 'vault',
    name: '납골당',
    showWhen: { clue: 'letter' },
    desc: '경기도 외곽의 납골당. 2층, 창가에서 세 번째 줄. 유리문 안에 부부의 사진과 작은 유골함 두 개가 있다. 유리문 앞 선반에는 방명록이 놓여 있고, 관리 직원 오 주임이 복도를 닦고 있다.',
    hotspots: [
      {
        id: 'niche',
        label: '부부의 자리를 본다',
        variants: [
          {
            lines: [
              n('「윤태준 1962–2010 · 김연희 1964–2010」. 사진 속 두 사람은 교무실 같은 곳에서 나란히 웃고 있다.'),
              n('유리문 손잡이에 달린 작은 꽃꽂이는 비어 있다.'),
              n('사진 옆에 손바닥만 한 플라스틱 판이 세워져 있다. 주기율표다. 윤태준 선생이 학생들에게 나눠 주던 것이라고 윤은호가 말한 적이 있다.'),
            ],
          },
        ],
      },
      {
        id: 'guestbook',
        label: '방명록을 넘겨 본다',
        variants: [
          {
            lines: [
              n('두꺼운 방명록이다. 이 자리 앞에만 15년 치가 쌓였다. 뒤에서부터 넘겼다.'),
              n('2024년 12월 10일. 「올해도 왔습니다. 형은 바쁩니다. 시호.」'),
              n('2023년 12월 10일. 「다녀갑니다. 시호.」 2022년 12월 10일. 「아버지, 어머니. 시호.」'),
              n('해마다 기일 전날이다. 볼펜을 꾹꾹 눌러 쓴 글씨. 종이 뒤로 자국이 밴다. 네 현장의 점검표에서, 그리고 편지에서 본 글씨다.'),
              n('2021년, 2020년, 2019년. 더 앞으로 넘겼다. 15년 동안 한 해도 거르지 않았다.'),
              n('올해 장에는 그 글씨가 없다.'),
            ],
            gives: ['guestbook'],
          },
        ],
      },
      {
        id: 'below',
        label: '올해 장에 적힌 줄을 읽는다',
        showWhen: { clue: 'guestbook' },
        variants: [
          {
            lines: [
              n('올해 장에는 다른 글씨가 있다. 가늘고 빠르다. 보고서 서명란에서 여러 번 본 글씨다.'),
              n('8월 3일. 「시호야. 형이 왔다 간다.」'),
              n('9월 14일. 「또 왔다.」 10월 26일. 「시호야.」 11월 16일. 「삼촌도 기다리신다.」'),
              n('마지막 줄은 12월 7일이다. 「시호야. 전화 받아라. 어디든 갈게. 형.」'),
              n('넉 달 동안 윤은호는 숨어 있지 않았다. 윤시호가 해마다 들르는 이 자리에 다섯 번을 왔다. 올 때마다 한 줄씩 남겼다.'),
              n('답은 한 줄도 없다.'),
            ],
            gives: ['brotherNote'],
          },
        ],
      },
    ],
  },
  {
    id: 'home',
    name: '윤은호의 집',
    showWhen: { flag: 'search' },
    desc: '국과수에서 버스로 세 정거장, 오래된 복도식 아파트 7층. 영장을 보이자 관리소 직원이 문을 열어 줬다. 현관 바닥에 넉 달 치 우편물이 쌓여 있다. 나는 이 집에 와 본 적이 있다. 가족으로 수색을 지켜보러 서해에서 올라온 삼촌 윤태수가 신발도 벗지 못한 채 현관에 서 있다.',
    hotspots: [
      {
        id: 'fridge',
        label: '냉장고를 본다',
        variants: [
          {
            lines: [
              n('냉장고 문에 누렇게 바랜 쪽지 두 장이 자석에 물려 있다. 위의 것은 삐뚤빼뚤한 아이 글씨다. 「11 · 31」. 아래 것은 조금 더 큰 아이의 글씨다. 「28 · 31 · 31」.'),
              n('나가. 니가 가.'),
              n('위의 쪽지는 연필을 얼마나 눌러 썼는지 종이가 패어 있다. 윤시호는 어릴 때도 그렇게 썼다.'),
              n('쪽지 옆에는 서해과학관 연간 회원 카드가 자석에 물려 있다. 「2인 · 2026년 1월까지」. 같은 카드가 한 장 내 지갑에 있다.'),
              n('냉장고 안은 비어 있다. 물 두 병뿐이다. 2월에 이 부엌에서 저녁을 얻어먹었다. 그날 쓴 냄비가 씻겨서 선반에 엎어져 있다.'),
            ],
            gives: ['fridge'],
          },
        ],
      },
      {
        id: 'room',
        label: '현관 옆 작은방 문을 연다',
        variants: [
          {
            lines: [
              n('현관 옆 작은방. 2월에 이 문 앞에서 윤은호가 말했었다. 동생 방이라고. 언제든 오라고 만들어 둔 방인데 아직 온 적은 없다고.'),
              n('1인용 침대에 이불이 개켜져 있다. 책상에는 스탠드와 빈 필통. 옷장에는 빈 옷걸이만 나란히 걸려 있다.'),
              n('책상 위에 열쇠가 하나 놓여 있다. 이 집 현관 열쇠다. 고리에 달린 이름표에 「시호」라고 적혀 있다. 이름표를 싼 비닐은 벗기지 않았다.'),
              n('이 방에서 잔 사람은 없다. 이불 위에 넉 달 치 먼지가 고르게 앉아 있다.'),
              say('uncle', '은호가 이사를 네 번 했는데 네 번 다 이 방을 만들었소. 시호는 한 번도 안 왔고.'),
            ],
            gives: ['room'],
          },
        ],
      },
      {
        id: 'wall',
        label: '거실 벽을 본다',
        variants: [
          {
            lines: [
              n('거실 한쪽 벽이 종이로 덮여 있다. 가운데에 전국 지도. 그 둘레에 종이 서른 장이 줄지어 붙어 있다. 한 장에 업체 하나다. 지난 4년 사이 폐업한 소방 유지보수 업체들이다.'),
              n('장마다 윤은호의 가늘고 빠른 글씨가 적혀 있다. 「대표 통화. 보조 인력 기억 못 함.」 「장부 없음. 일당 현금.」 「자격증 주인은 현장에 안 감.」'),
              n('열한 장에 붉은 줄이 그어져 있다. 줄 옆에는 다녀온 날짜가 있다. 4월 19일부터 7월 27일까지. 전부 토요일이나 일요일이다.'),
              n('나머지 열아홉 장에는 줄이 없다. 지도에는 핀이 열아홉 개 꽂혀 있다. 윤은호는 8월에 이 열아홉 곳의 주소를 들고 나갔다.'),
              n('수사본부가 여덟 달 동안 전화로 돌린 업체들이다. 윤은호는 한 곳씩 직접 찾아갔다. 혼자서.'),
              n('지도 아래 바닥에 서류철 하나가 놓여 있다.'),
            ],
            gives: ['tracing'],
          },
        ],
      },
      {
        id: 'binder',
        label: '바닥의 서류철을 넘긴다',
        showWhen: { clue: 'tracing' },
        variants: [
          {
            lines: [
              n('서류철 등에 윤은호의 글씨로 적혀 있다. 「시호. 2014–2021」.'),
              n('첫 장은 2014년 3월의 입사 지원서다. 서해의 소방 설비 업체, 보조 기사. 열아홉 살이다. 지원 동기 칸에 두 줄이 적혀 있다. 「2010년 한성물류센터 화재로 부모님을 잃었습니다. 그날 스프링클러 밸브는 잠겨 있었습니다.」'),
              n('다음 장은 2016년에 딴 소방설비 자격증 사본이다.'),
              n('그 뒤로는 점검표 사본이다. 전부 같은 글씨다. 볼펜으로 꾹꾹 눌러 쓴 글씨.'),
              n('2015년 6월, 요양원. 「스프링클러 밸브 잠김. 개방 요망. 관리자 서명 거부.」 뒤에 소방서 신고 접수증이 붙어 있다. 신고인 윤시호. 처리 결과. 「현장 확인 시 정상 작동. 종결.」'),
              n('2017년 11월, 고시원. 「비상구 자물쇠. 제거 요망. 관리자 서명 거부.」 신고인 윤시호. 「시정 권고. 종결.」'),
              n('2019년 4월, 물류 창고. 「화재 경보 차단. 복구 요망. 관리자 서명 거부.」 신고인 윤시호. 「현장 확인 시 정상 작동. 종결.」'),
              n('세어 봤다. 점검표가 스물세 장, 접수증이 스물세 장이다. 처리 결과 칸에 과태료나 고발이 적힌 것은 한 장도 없다.'),
              n('사이사이에 다른 종이가 석 장 끼어 있다. 해고 통지서다. 2016년, 2018년, 2020년. 사유는 셋 다 같다. 「거래처의 계약 해지 요구.」'),
              n('세 번째 통지서의 여백에 윤은호가 연필로 적어 놓았다. 「업체 대표 통화. 일은 잘했다고 함. 걔가 다녀간 건물마다 소방서에서 사람이 나왔고, 그러면 거래처가 떨어진다고 함.」'),
              n('네 현장의 메모에 적혀 있던 말이 여기서 왔다. 복구 요망. 관리자 서명 거부. 윤시호는 7년 동안 그 말을 쓰고, 그 종이를 들고 소방서에 갔다.'),
            ],
            gives: ['reports'],
          },
        ],
      },
      {
        id: 'judgment',
        label: '서류철 뒤쪽의 판결문을 읽는다',
        showWhen: { clue: 'reports' },
        variants: [
          {
            lines: [
              n('스물세 번째 점검표는 2021년 1월 것이다. 경기 평택의 냉동 창고. 「화재 경보 차단. 냉동실 작업 중 불이 나면 대피 불가. 복구 요망. 관리자 서명 거부.」 신고인 윤시호. 「현장 확인 시 정상 작동. 종결.」'),
              n('그 뒤에 신문 기사 한 장. 2021년 2월 17일. 「평택 냉동 창고 화재, 1명 사망. 숨진 이는 냉동실에서 일하던 아르바이트생(21). 경보는 울리지 않았다.」'),
              n('점검표를 쓰고 3주 뒤다.'),
              n('그 뒤에 판결문. 2021년 10월 28일 선고. 창고 대표, 징역 1년 6개월에 집행유예 3년. 그 창고를 해마다 점검하고 「양호」 판정을 낸 점검업체 대표, 징역 8개월에 집행유예 2년.'),
              n('점검업체 대표의 이름에 윤은호가 붉은 줄을 그어 놓았다. 표영달. 2010년 한성물류센터에 「양호」를 찍어 준 사람이다.'),
              n('판결문을 끝까지 읽었다. 3주 전의 그 점검표는 어디에도 나오지 않는다.'),
              n('마지막 장 여백에 윤은호의 메모가 두 줄 있다. 「선고 당일 오후. 휴대폰 해지, 계좌 해지, 고시원 퇴실.」 「그 뒤 기록 없음.」'),
              n('2024년 2월, 홍천에서 구상철이 죽었다. 7월, 화성에서 표영달이 죽었다.'),
            ],
            gives: ['judgment'],
          },
        ],
      },
      {
        id: 'unsent',
        label: '판결문 뒤에 낀 봉투를 연다',
        showWhen: { clue: 'judgment' },
        variants: [
          {
            lines: [
              n('서류철 맨 뒤 비닐에 흰 봉투가 끼워져 있다. 봉하지 않았다. 겉에 윤은호의 글씨로 「서지안 씨께」. 우표는 없다.'),
              n('편지지 한 장이다. 날짜는 7월 31일. 휴직 전날이다.'),
              n('「지안 씨. 4월에 그 숫자를 봤을 때 알았습니다. 39, 92, 7. 제 동생이 쓰는 글자입니다. 시간을 달라고 한 것은 확인하려던 게 아니었습니다. 아니기를 바랐습니다.」'),
              n('「동생 이름은 시호입니다. 넉 달 동안 걔가 일한 곳을 찾아다녔습니다. 걔가 쓴 점검표를 스물세 장 읽었습니다. 저는 걔가 그렇게 일하는 줄 몰랐습니다. 15년 동안 한 번도 묻지 않았습니다.」'),
              n('「지안 씨에게 말해야 한다는 것을 압니다. 말하면 수사본부가 걔를 찾을 것이고, 찾으면 총을 든 사람들이 걔 앞에 설 겁니다. 걔는 물러서지 않을 겁니다. 저는 그걸 볼 수가 없습니다.」'),
              n('「불이 났을 때 걔는 중학교 3학년이었습니다. 저는 그 애를 삼촌 집에 두고 서울로 갔습니다. 두고 간 사람이 저니까 데려오는 것도 제가 해야 합니다.」'),
              n('「옳지 않다는 것도 압니다. 제가 찾는 동안 누가 또 다칠 수 있습니다. 그래도 이렇게 합니다. 부끄럽습니다.」'),
              n('「전화기는 꺼 두겠습니다. 지안 씨 목소리를 들으면 다 말하게 될 것 같아서요. 토요일은 제가 맞추겠다고 해 놓고 못 맞췄습니다. 미안합니다. 윤은호.」'),
              n('편지를 접어 증거물 봉투에 넣었다. 접는 데 시간이 걸렸다.'),
            ],
            gives: ['unsent'],
          },
        ],
      },
    ],
  },
  {
    id: 'incheon',
    name: '인천 신물류센터',
    showWhen: { clue: 'schedule' },
    desc: '인천항 뒤편에 새로 지은 한성의 물류센터. 축구장 여섯 배 넓이다. 준공식 무대가 올라가고 있고, 구석구석에 수사본부 형사들이 서 있다. 하 센터장이 안전모를 내밀었다.',
    hotspots: [
      {
        id: 'tour',
        label: '센터 안을 둘러본다',
        variants: [
          {
            lines: [
              n('천장의 스프링클러 배관에 초록 꼬리표가 달려 있다. 「밸브 열림.」 밸브 손잡이는 열린 채 납 봉인으로 묶여 있다.'),
              n('비상구마다 문을 밀어 봤다. 전부 열린다. 문 앞에 쌓인 짐도 없다. 바닥에는 노란 선으로 「물건 적치 금지」.'),
              n('15년 전의 물류센터에는 없던 것들이다. 그때는 밸브가 잠겨 있었고 비상구에는 자물쇠가 걸려 있었다.'),
              n('이산화탄소로 방을 채우는 설비는 이 건물에 없다. 하 센터장 말로는 가스로 불을 끄는 설비는 전기실 한 곳뿐이고, 그것도 이산화탄소가 아닌 다른 가스다.'),
            ],
          },
        ],
      },
      {
        id: 'sheet',
        label: '방재실의 점검표를 본다',
        variants: [
          {
            lines: [
              n('방재실 벽의 점검표 철을 처음부터 넘겼다. 시운전을 시작한 9월부터 석 달 치다.'),
              n('「스프링클러 밸브: 열림.」 「화재 경보: 정상.」 「비상구: 열림.」 지적 사항 칸은 달마다 같다. 「없음.」'),
              n('관리자 확인 칸에는 전부 서명이 있다. 「서명 거부」라는 글자는 어디에도 없다. 꾹꾹 눌러 쓴 그 글씨도 없다.'),
              n('철의 맨 뒤에 붙은 설비 목록도 봤다. 가스로 불을 끄는 설비는 전기실 한 곳뿐이고, 이산화탄소가 아니다.'),
              n('봄에 네 현장에서 걷어 온 점검표들과 나란히 놓고 봤다. 같은 양식인데 닮은 데가 하나도 없다.'),
            ],
            gives: ['incheonClean'],
          },
        ],
      },
      {
        id: 'stage',
        label: '준공식 무대를 본다',
        variants: [
          {
            lines: [
              n('무대 뒤 현수막. 「한성, 안전으로 다시 서다.」 기자석이 예순 개다.'),
              n('수사본부는 12월 11일 오전에 형사 예순 명 전원을 이곳에 세울 계획이다. 15년 전에 탄 것이 물류센터였으니, 범인이 그 장면을 되풀이할 것이라는 계산이다.'),
              n('무대 옆에는 소화기가 열 걸음마다 놓였다. 문 대장이 이곳에서 막으려는 것은 불이다.'),
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'hansung',
    name: '한성 본사',
    showWhen: { clue: 'schedule' },
    desc: '서울 강남의 20층 사옥. 로비의 「안전경영 대상」 트로피는 그 자리에 있고, 회장의 경호원은 여섯으로 늘었다. 행사를 앞두고 모자에 마스크를 쓴 조끼 차림의 하청 인력이 로비를 쉴 새 없이 가로지른다. 변재만 회장은 이번에도 10분을 내줬다.',
    hotspots: [
      {
        id: 'lobby',
        label: '로비의 안내문을 본다',
        variants: [
          {
            lines: [
              n('로비 한가운데 세운 안내판. 「한성그룹 창립 30주년 기념식. 12월 11일 목요일 저녁 7시. 지하 2층 컨벤션홀.」'),
              n('그 아래 작은 글씨. 「초청 대상: 근속 20년 이상 임직원, 창립 협력사. 어려울 때 한성의 곁을 지켜 주신 분들을 모십니다.」'),
              n('식순이 적혀 있다. 「7시 개회. 7시 10분 30년 기념 영상. 7시 40분 회장 건배사. 8시 만찬.」'),
              n('안내 데스크 직원이 승강기 쪽을 가리켰다. 컨벤션홀은 지하 2층이고, 지금 무대를 설치하는 중이니 보려면 총무팀 채 과장을 찾으라고 했다.'),
              n('7시 40분. 회장이 잔을 드는 시각이다. 그 줄을 수첩에 옮겨 적었다.'),
            ],
            gives: ['invitation'],
          },
        ],
      },
    ],
  },
  {
    id: 'hall',
    name: '지하 컨벤션홀',
    showWhen: { clue: 'invitation' },
    desc: '본사 지하 2층. 원탁 백 개가 들어가는 창 없는 홀이다. 무대에는 「30」이라는 숫자가 올라가고 있고, 사다리 꼭대기에서는 파란 조끼를 입은 조명 기사가 천장 격자 속에 상체를 넣고 등을 달고 있다. 홀 밖은 로비, 로비 양 끝에 지상으로 올라가는 계단이 둘 있다. 총무팀 채 과장이 좌석표를 들고 뛰어다닌다.',
    hotspots: [
      {
        id: 'ceiling',
        label: '천장을 올려다본다',
        variants: [
          {
            lines: [
              n('천장은 검은 격자 마감재로 가려져 있다. 격자 틈으로 손전등을 비췄다.'),
              n('굵은 붉은 배관이 천장을 가로지른다. 배관에서 가지가 내려오고, 가지 끝마다 나팔처럼 벌어진 쇠 주둥이가 달려 있다. 세어 보니 스물네 개다.'),
              n('스프링클러가 아니다. 물이 나오는 꼭지는 저렇게 생기지 않았다.'),
              n('무대 옆 벽에 현수막으로 반쯤 가린 낡은 표지판이 있다. 현수막을 들췄다. 「경고. 이산화탄소 방출 구역. 경보가 울리면 즉시 이 방에서 나가시오.」'),
              n('채 과장이 다가와 겸연쩍게 웃었다.'),
              say('chae', '아, 그거요. 여기가 5년 전까지 그룹 전산센터였거든요. 서버를 밖으로 옮기고 연회장으로 고쳤어요. 저건 그때 쓰던 소화 설비예요.'),
              say('chae', '철거 견적이 2억이 나왔대요. 어차피 안 쓰는 건데 돈 들이지 말라고 해서, 천장만 가리고 그냥 뒀죠. 표지판은 보기 싫어서 현수막으로 가렸고요.'),
              me('안 쓰는 거면, 꺼져 있습니까.'),
              say('chae', '그건… 방재실에 물어보셔야 해요. 지하 1층이에요. 저는 총무라서요.'),
            ],
            gives: ['gasSystem'],
          },
        ],
      },
      {
        id: 'doorsSpot',
        label: '출입문을 세어 본다',
        variants: [
          {
            lines: [
              n('홀의 문은 넷이다. 로비로 난 정문 하나, 그리고 양옆과 뒤쪽에 옆문 셋. 전부 두꺼운 철문이다.'),
              n('옆문 셋은 지금도 잠겨 있다. 문틀 위에 손바닥만 한 쇳덩이가 붙어 있다. 전기가 흐르는 동안 문을 붙잡고 있는 전자석이다.'),
              say('chae', '행사 때는 정문 하나로만 입장을 받아요. 옆문을 열어 두면 명찰 없는 사람이 들어오거든요.'),
              me('불이 나면요.'),
              say('chae', '원래는 화재 신호가 오면 전자석이 저절로 풀려요. 근데 재작년 송년회 때 경보가 잘못 울려서 문이 다 열려 버렸어요. 회장님 말씀 중에요. 그 뒤로 그 기능은 꺼 놨습니다.'),
              n('그는 그 말을 아무렇지 않게 했다. 15년 전에도 누군가 이렇게 아무렇지 않게 말했을 것이다.'),
              n('문마다 옆 벽에 초록색 상자가 붙어 있다. 「비상 개방. 덮개를 깨고 누르시오.」 채 과장이 옆문 하나의 덮개를 열쇠로 열고 단추를 눌러 보였다. 찰칵, 전자석이 떨어지고 문이 밀렸다.'),
              say('chae', '이건 그 문 하나의 전기를 끊는 거예요. 방재실 화면이 뭐라고 하든 상관없이요. 문 넷에 상자 넷입니다.'),
              n('저 전자석은 어른 서넛이 매달려도 버틴다고 했다. 대신 전기가 끊기면 그냥 놓는다. 힘으로는 안 열리고, 단추 하나로는 열린다.'),
            ],
            gives: ['doors'],
          },
        ],
      },
      {
        id: 'curtain',
        label: '정문 옆 커튼 뒤를 본다',
        showWhen: { clue: 'gasSystem' },
        variants: [
          {
            lines: [
              n('정문 바로 안쪽 벽에 두꺼운 암막 커튼이 드리워 있다. 젖혔다.'),
              n('붉은 철제 함이 벽에 박혀 있다. 「이산화탄소 소화설비 수동 조작함」. 앞면은 유리 덮개다. 요즘 것처럼 잘게 부서지는 유리가 아니라 옛날식 판유리다. 「비상시 유리를 깨고 조작하시오.」'),
              n('유리 너머로 단추 두 개가 보인다. 붉은 단추에는 「수동 기동」, 노란 단추에는 「방출 지연」. 그 위에 숫자가 뜨는 작은 창이 있다. 지금은 꺼져 있다.'),
              say('chae', '그것도 전산센터 때 거예요. 원래는 문 밖에 있었는데, 연회장으로 고치면서 홀을 넓히느라 벽을 로비 쪽으로 밀었거든요. 그래서 함이 홀 안으로 들어와 버렸죠.'),
              say('chae', '보기 흉해서 커튼을 쳤어요.'),
              n('표지판은 현수막으로, 분사구는 격자로, 조작함은 커튼으로. 이 방은 가릴 수 있는 것을 전부 가려 놓았다.'),
            ],
            gives: ['cabinet'],
          },
        ],
      },
    ],
  },
  {
    id: 'control',
    name: '본사 방재실',
    showWhen: { clue: 'gasSystem' },
    desc: '지하 1층 방재실. 벽 한 면이 화재 수신기다. 건물 곳곳의 감지기가 보내는 신호가 모이는 판이다. 초록 불 사이사이에 주황 불이 섞여 있다. 엄 팀장이 커피를 타고 있다. 수신기 맨 끝의 함은 주황 조끼를 입은 소방 점검 기사의 자리다. 방재실에 있을 때면 늘 그 함 안에 상체를 넣고 일한다. 문간에서는 연두 조끼를 입은 청소 업체 직원 둘이 마스크를 쓴 채 바닥 닦는 기계를 밀고 있다.',
    hotspots: [
      {
        id: 'panel',
        label: '수신기의 주황 불을 본다',
        variants: [
          {
            lines: [
              n('수신기에는 구역마다 작은 불이 켜져 있다. 초록은 정상. 주황 불 밑에는 같은 글자가 붙어 있다. 「차단」.'),
              n('세어 봤다. 열일곱 개다. 주차장 경보, 식당 주방 감지기, 3층 방화 셔터, 지하 컨벤션홀 출입문.'),
              say('eom', '잘못 울리는 일이 잦은 것들이에요. 울릴 때마다 민원이 들어와서요. 다들 그렇게 합니다.'),
              n('다들 그렇게 한다. 13년 전 재판에서 다섯 명이 한 말도 그것이었다. 관행이었다.'),
              n('「지하 2층 가스 소화설비」 칸에는 초록 불이 켜져 있다. 꺼져 있지 않다. 살아 있다는 뜻이다.'),
            ],
          },
        ],
      },
      {
        id: 'binder',
        label: '점검표 철을 넘겨 본다',
        variants: [
          {
            when: { flag: 'askedOut' },
            lines: [
              n('수신기 옆 선반의 점검표 철. 지난 4월 전화로 물었을 때 이 방재실은 「그런 메모는 없습니다」라고 했다. 그때는 사실이었을 것이다.'),
              n('5월, 6월, 7월, 8월. 지적 사항 없음. 9월에서 손이 멈췄다.'),
              n('「지하 2층 컨벤션홀은 옛 전산센터임. 용도 변경 후에도 이산화탄소 소화설비가 그대로 남아 있음. 사람이 모이는 곳에 둘 수 없는 설비임. 철거 요망.」'),
              n('그 아래, 같은 글씨로 한 줄. 「관리자 서명 거부.」'),
              n('볼펜으로 꾹꾹 눌러 쓴 글씨다. 편지의 글씨다. 점검자 서명은 흘려 썼다. 봄에 네 현장의 점검표에서 본 서명이다. 이제는 읽힌다. 윤시호.'),
              n('다섯 번째다. 홍천, 화성, 부산, 음성. 그리고 여기.'),
              n('앞의 네 번은 한 사람씩이었다. 이 방에는 천 명이 들어간다.'),
            ],
            gives: ['fifthNote'],
          },
          {
            lines: [
              n('수신기 옆 선반의 점검표 철. 지난 4월 전화로 물었을 때 이 방재실은 「그런 메모는 없습니다」라고 했다. 그때는 사실이었을 것이다.'),
              n('5월, 6월, 7월, 8월. 지적 사항 없음. 9월에서 손이 멈췄다.'),
              n('「지하 2층 컨벤션홀은 옛 전산센터임. 용도 변경 후에도 이산화탄소 소화설비가 그대로 남아 있음. 사람이 모이는 곳에 둘 수 없는 설비임. 철거 요망.」'),
              n('그 아래, 같은 글씨로 한 줄. 「관리자 서명 거부.」'),
              n('볼펜으로 꾹꾹 눌러 쓴 글씨다. 편지의 글씨다. 점검자 서명은 흘려 썼다. 봄에 네 현장의 점검표에서 본 서명이다. 이제는 읽힌다. 윤시호.'),
              say('eom', '그건 9월에 전 업체 기사가 쓴 겁니다. 그 업체는 9월 말로 계약이 끝났어요. 마 기사, 자네는 10월에 왔지?'),
              say('tech', '네. 10월부터입니다.'),
              n('수신기 끝의 함 안에서 대답만 나왔다. 낮고 차분한 목소리다. 주황 조끼의 등은 돌아보지 않았다.'),
              n('다섯 번째다. 홍천, 화성, 부산, 음성. 그리고 여기.'),
              n('앞의 네 번은 한 사람씩이었다. 이 방에는 천 명이 들어간다.'),
            ],
            gives: ['fifthNote'],
          },
        ],
      },
      {
        id: 'basement',
        label: '엄 팀장과 지하 3층에 내려가 본다',
        variants: [
          {
            lines: [
              n('엄 팀장이 방재팀 카드를 들고 앞장섰다. 계단으로 두 층을 내려갔다.'),
              n('지하 3층 계단문을 나서면 주차장이다. 문 옆 벽에 회색 조작반이 붙어 있다. 단추가 둘이다. 「주차장·기계실 배기팬」, 「경사로 셔터」.'),
              say('eom', '배기팬은 지하 3층 공기를 빨아서 지상으로 내보내는 겁니다. 평소에는 시간 맞춰 저절로 돌고, 급할 때 이걸 누르면 바로 돕니다. 경사로 셔터는 차 올라가는 길을 막는 건데, 행사 날에는 내려 둡니다.'),
              n('조작반 옆에는 붉은 소화전함이 있다. 불을 끌 때 쓰는 호스가 둥글게 말려 들어 있다.'),
              n('가스 저장실은 거기서 계단 열 단을 더 내려간 기계실 복도에 있다. 주차장 바닥보다 반 층이 낮다. 이 건물에서 제일 낮은 자리다. 복도 벽 아래쪽에는 쇠살을 댄 배기구가 둘 뚫려 있다.'),
              n('계단 밑에서 저장실 철문까지 걸음을 세어 봤다. 여덟 걸음.'),
              n('철문 옆 벽에 노란 함이 하나 붙어 있다. 「공기호흡기」. 열어 봤다. 등에 메는 공기통과 얼굴을 덮는 마스크가 한 벌 걸려 있다. 옆의 고리 하나는 비어 있다.'),
              say('eom', '이산화탄소 설비가 있는 건물은 그걸 갖춰 놔야 합니다. 원래 두 벌이었는데 하나는 재작년에 고장 나서 내렸어요. 새로 사 달라고 올려는 놨습니다.'),
              n('함 문 안쪽의 점검표를 봤다. 마지막 날짜는 2023년 6월이다. 공기통의 눈금 바늘은 초록 칸 안에 있다.'),
              n('엄 팀장이 카드를 대자 철문이 열렸다. 붉은 가스통 마흔 개가 네 줄로 서 있다. 통마다 배관이 천장으로 올라간다. 벽 쪽에는 배관에 물리지 않은 통 둘이 따로 서 있다. 꼬리표에 「예비」라고 적혀 있다.'),
              n('안쪽 벽에 제어반이 있다. 열쇠를 꽂는 자리 위에 「자동 · 정지」. 그 옆에 붉은 레버. 「수동 방출」.'),
              say('eom', '열쇠는 마 기사가 갖고 다닙니다. 저는 이 방에 1년에 두 번 들어와요.'),
              n('4월에 윤은호가 일러 준 순서가 떠올랐다. 들어가지 말 것. 가스를 잠그고 바람부터 넣을 것. 꼭 들어가야 하면 공기통을 메고, 밖에서 줄을 잡아 줄 사람을 둘 것.'),
              n('이 복도에서 사람이 쓰러지면 쓸 수 있는 공기통은 하나다.'),
            ],
            gives: ['basement', 'rescueRule'],
          },
        ],
      },
    ],
  },
  {
    id: 'phone',
    name: '휴대폰',
    desc: '코트 주머니의 휴대폰. 대화 목록 맨 위에 있던 이름은 이제 한참 아래로 내려갔다.',
    hotspots: [
      {
        id: 'call',
        label: '그의 번호로 전화를 건다',
        variants: [
          {
            lines: [
              n('아침마다 하는 일이다. 윤은호의 이름을 눌러 전화를 건다.'),
              n('「전원이 꺼져 있어 삐 소리 후 소리샘으로 연결되오며…」'),
              n('소리샘에 말을 남긴 것은 8월에 한 번뿐이다. 무슨 말을 했는지는 기억나지 않는다. 오늘도 안내를 끝까지 듣고 끊었다.'),
            ],
          },
        ],
      },
      {
        id: 'chat',
        label: '윤은호와의 대화방을 연다',
        variants: [
          {
            lines: [
              n('마지막으로 주고받은 것은 6월 말이다.'),
              n('나: 「확인해 본다던 거, 어떻게 됐어요.」'),
              n('윤은호: 「조금만 더요. 미안해요.」'),
              n('그 뒤로는 내 말만 쌓여 있다. 「밥은 먹고 다녀요.」 「전화 좀 받아요.」 「국과수에 갔더니 휴직했다던데요.」 「화난 거 아니에요. 걱정하는 거예요.」'),
              n('8월부터는 메시지 옆의 숫자 1이 지워지지 않는다.'),
            ],
          },
        ],
      },
      {
        id: 'draft',
        label: '입력창에 쓰다 만 글을 본다',
        showWhen: { clue: 'yun' },
        variants: [
          {
            when: { clue: 'cctv' },
            lines: [
              n('새벽에 쓴 글이 입력창에 남아 있다.'),
              n('「본사 지하에서 뭘 했는지 봤어요. 문이 안 열렸죠.」'),
              n('보내지 않았다. 수사본부가 찾는 사람에게 수사본부가 무엇을 봤는지 알려 줄 수는 없다. 한 글자씩 지웠다.'),
              n('윤은호에게서 연락이 오면 보고한다. 내가 약속한 것은 그것이고, 지금 내가 할 수 있는 것도 거기까지다.'),
            ],
          },
          {
            when: { clue: 'unsent' },
            lines: [
              n('그의 집에서 돌아오는 차 안에서 쓴 글이 입력창에 남아 있다.'),
              n('「편지 읽었어요. 부치지 않은 거요.」'),
              n('그 뒤에 무슨 말을 이어야 할지 몰랐다. 화가 난다고 쓸지, 어디 있느냐고 쓸지. 둘 다 썼다가 둘 다 지웠다.'),
            ],
          },
          {
            when: { clue: 'brotherNote' },
            lines: [
              n('납골당에서 돌아오는 차 안에서 쓴 글이 입력창에 남아 있다.'),
              n('「방명록 봤어요. 혼자 찾지 마요.」'),
              n('보내기 단추 위에서 엄지가 한참 멈춰 있었다. 누르지 않았다.'),
            ],
          },
          {
            lines: [
              n('모니터의 메모지를 읽은 뒤에 쓴 글이 입력창에 남아 있다.'),
              n('「4월에 알았죠.」'),
              n('물음표는 붙이지 않았다. 보내지 않고 지웠다.'),
            ],
          },
        ],
      },
    ],
  },
];

export const VICTIM = {
  id: 'victim',
  name: '남기찬',
  age: 55,
  role: '음성 식품공장 공장장',
  tag: '피해자',
  desc: '지난 4월, 질소가 찬 탱크에서 숨졌다. 네 번째다. 15년 전 화재로 재판을 받은 다섯 명 가운데 넷이 죽었고 하나가 남았다.',
};

export const PEOPLE = [
  {
    id: 'moon',
    name: '문 대장',
    age: 55,
    role: '수사본부장',
    tag: '팀',
    loc: 'hq',
    desc: '광역수사대장이자 수사본부장. 봄에는 종결된 사고를 다시 여는 것을 꺼렸고, 지금은 여덟 달째 못 닫는 사건에 지쳐 있다. 증거 앞에서는 말을 바꿀 줄 안다. 그 증거가 내게 불리할 때도 그렇다.',
    topics: [
      {
        id: 'why',
        label: '동생이 형에게 쓴 편지',
        lines: [
          say('moon', '범인이 식구한테 쓴 편지야. 우리 보라고 쓴 게 아니니까 거짓말할 이유가 없어. 날짜도, 숫자로 적은 것도 진짜일 거야.'),
          say('moon', '걸리는 건 받는 사람이지. 이놈한테 형이 있고, 그 형이 우리가 봄 내내 분석을 맡긴 사람이야.'),
        ],
      },
      {
        id: 'search',
        label: '윤은호를 찾는 이유',
        when: { flag: 'search' },
        lines: [
          say('moon', '나도 반갑지 않아. 봄에 우리 일을 도와준 사람이고, 서 경위 사람인 것도 알아.'),
          say('moon', '그런데 서 경위. 유족이고, 전문가고, 한 건을 제 손으로 사고라고 썼고, 동생 짓인 줄 알고도 말을 안 했고, 넉 달째 사라졌어. 다른 사람 이름이 이 자리에 올라와 있으면 서 경위는 뭐라고 하겠어.'),
          me('…찾아야 한다고 하겠죠.'),
          say('moon', '그럼 그렇게 해. 한패가 아니라는 증거를 가져오면 듣는다. 믿음 말고 증거.'),
        ],
      },
      {
        id: 'cancel',
        label: '기념식을 막을 수 없는가',
        when: { clue: 'schedule' },
        lines: [
          say('moon', '취소해 달라는 공문은 보냈어. 인천에도 본사에도. 돌아온 답은 「경비를 강화하겠음」이야.'),
          say('moon', '편지 한 장으로 남의 회사 행사를 강제로 막을 수는 없어. 어디서, 뭘로 할 건지가 나와야 막든 비우든 해. 지금 우리가 아는 건 날짜하고 가스 이름뿐이고.'),
        ],
      },
    ],
    present: {
      yun: {
        lines: [
          say('moon', '원자 번호… 여덟 달을 품번 대장만 뒤졌는데. 그 집 식구만 읽는 글자였네.'),
        ],
      },
      noRecord: {
        lines: [
          say('moon', '4년 전에 서류에서 사라졌다. 그래서 이름이 안 나왔던 거야. 9년 전 증명사진 한 장으로 모자에 마스크 쓴 놈을 찾아야 한다는 거네.'),
        ],
      },
      brotherNote: {
        lines: [
          say('moon', '동생을 찾는 중이다… 아니면 동생한테 연락하는 중이거나. 한패끼리도 저렇게 써. 그 줄만으로는 어느 쪽인지 몰라.'),
        ],
      },
      schedule: {
        lines: [
          say('moon', '오전 인천, 저녁 본사. 예순 명이 두 군데 다 선다. 문제는 그놈이 어느 쪽에서 뭘 하느냐야. 나는 인천에서 불이라고 본다.'),
        ],
      },
      cctv: {
        lines: [
          say('moon', '봤지. 서 경위 눈에는 돌아선 사람이고 내 눈에는 미리 둘러본 사람이야. 눈으로는 못 가려. 증거를 가져와.'),
        ],
      },
      gasSystem: {
        lines: [
          say('moon', '연회장 천장에 가스 설비라. 안 쓰는 설비라며. 누가 그걸 쓰려고 한다는 흔적이 있으면 그걸 가져와.'),
        ],
      },
      fifthNote: {
        lines: [
          say('moon', '본사 지하에 그 메모가 있다고. …알았어. 그런데 이 한 장으로 배치를 못 바꿔. 인천이 아니라는 것까지 묶어서 가져와.'),
        ],
      },
      unsent: {
        lines: [
          say('moon', '…서 경위한테 쓴 거네. 이건 회의 때 꺼내. 다른 것들하고 같이 듣는다.'),
        ],
      },
    },
    fallback: [say('moon', '하나씩 들고 오지 말고 묶어서 가져와. 들을 때는 한 번에 듣는다.')],
  },
  {
    id: 'kwak',
    name: '곽 경사',
    age: 41,
    role: '광역수사대',
    tag: '팀',
    loc: 'hq',
    desc: '15년 차. 여덟 달째 서지안과 한 조다. 운전하는 내내 투덜대는 것도, 차를 돌린 적이 없는 것도 그대로다. 요즘은 조수석을 흘끔거리는 일이 늘었다.',
    topics: [
      {
        id: 'drive',
        label: '운전',
        lines: [
          say('kwak', '국과수가 두 시간이야. 그다음은 또 어디야. 사흘 동안 전국을 돌 판이네.'),
          say('kwak', '…호두과자 사 놨어. 뒷자리에. 서 경위 밥 안 먹는 거 아니까.'),
        ],
      },
      {
        id: 'honest',
        label: '곽 경사의 속마음',
        when: { flag: 'search' },
        lines: [
          say('kwak', '솔직히 말해? 나는 반반이야.'),
          say('kwak', '봄에 본 윤 연구관은 그럴 사람이 아니었어. 서 경위 가방에 멀미약 넣어 주던 사람이잖아. 근데 그 사람, 동생 짓인 줄 알고도 여덟 달을 입 다물었어. 그건 사실이야.'),
          say('kwak', '하나만 물을게. 형제가 한패면 어쩔 거야.'),
          me('잡아야죠.'),
          say('kwak', '아니면.'),
          me('아니라는 걸 증명해야죠. 그것도 제 일이에요.'),
          say('kwak', '…그래. 그럼 운전은 내가 할게.'),
        ],
      },
    ],
    present: {
      guestbook: {
        lines: [
          say('kwak', '15년을 하루도 안 틀리고 오던 사람이 올해는 안 왔다. …편지에 쓴 대로네.'),
        ],
      },
      fifthNote: {
        lines: [
          say('kwak', '천 명 들어가는 방에 그 메모가 있다고? …서 경위, 이건 대장한테 들고 가야 돼. 제대로 묶어서.'),
        ],
      },
      maPaper: {
        lines: [
          say('kwak', '여든세 명이 다 깨끗해. 집에 전화까지 넣어 봤잖아. 서류로 볼 수 있는 건 다 본 거야.'),
        ],
      },
      unsent: {
        lines: [
          say('kwak', '…다 읽었어. 이건 내가 뭐라고 할 게 아니네.'),
          n('곽 경사는 편지를 봉투에 도로 넣어 두 손으로 내밀었다.'),
        ],
      },
    },
    fallback: [say('kwak', '그건 대장한테 물어. 나는 운전 담당이야.')],
  },
  {
    id: 'ahn',
    name: '안 연구사',
    age: 29,
    role: '국과수 연구사',
    tag: '참고인',
    loc: 'nfs',
    desc: '윤은호의 3년 후배. 그의 실험실 옆방을 쓴다. 문에 그 포스트잇을 붙인 장본인이다. 선배 얘기를 할 때마다 불 꺼진 문 쪽을 한 번씩 본다.',
    topics: [
      {
        id: 'leave',
        label: '윤은호의 휴직',
        lines: [
          say('ahn', '7월 말에 갑자기 내셨어요. 사유는 가족 사정이라고만요. 선배한테 가족이 있다는 것도 저는 그때 처음 알았어요.'),
          say('ahn', '4월부터 좀 달라지긴 했어요. 주말마다 어디를 다녀오시는데, 월요일에 보면 잠을 못 잔 얼굴이었어요.'),
          say('ahn', '그때 저한테 부탁한 게 있어요. 전국 소방 유지보수 업체 등록 대장을 떼어 달라고. 그중에서 지난 4년 사이에 폐업한 곳만 추려 달라고요. 서른 곳이었어요.'),
          say('ahn', '휴직 직전에 가져간 자료는 둘이에요. 한성그룹 건물들의 소방 설비 현황, 그리고 자료실의 「이산화탄소 소화설비 사고 조사집」. 아직 반납 안 하셨고요.'),
          me('뭘 찾는다고는 안 했어요?'),
          say('ahn', '물어봤죠. 「사람 하나」라고만 하셨어요. 「내가 먼저 찾아야 하는 사람」이라고.'),
        ],
        gives: ['trail'],
      },
      {
        id: 'co2',
        label: '이산화탄소 소화설비',
        when: { clue: 'decoded' },
        lines: [
          say('ahn', '이산화탄소요? 불 끄는 설비에 많이 써요. 물을 뿌리면 안 되는 곳, 전산실이나 전기실 같은 데요.'),
          say('ahn', '원리는 단순해요. 방 하나를 가스로 가득 채워서 산소를 밀어내는 거예요. 산소가 모자라면 불이 꺼지니까요.'),
          say('ahn', '문제는 불만 꺼지는 게 아니라는 거죠. 그 방에 사람이 있으면 몇 번 숨에 정신을 잃어요. 산소가 모자라서만이 아니에요. 진한 이산화탄소는 그 자체가 몸에 독이라서요.'),
          say('ahn', '그리고 공기보다 1.5배쯤 무거워요. 터지면 바닥으로 깔리고, 문틈으로 새면 낮은 데로 흘러가요. 계단이 있으면 계단 밑에 고이고요.'),
          say('ahn', '터질 때 하얗게 보이는 건 가스가 아니에요. 가스가 차가워서 공기 속의 물기가 김이 되는 거예요. 가스 자체는 눈에 안 보여요. 김이 걷혔다고 들어가면 안 돼요.'),
          say('ahn', '그래서 이 설비는 터지기 전에 반드시 경보가 먼저 울려요. 사람이 나갈 시간을 주는 거죠. 설비가 있는 건물에는 공기호흡기도 갖춰 두게 돼 있어요. 공기통을 메고 마스크로 숨 쉬는 장비요.'),
          n('불에서 나오는 가스가 아니라 불을 끄는 가스. 편지의 6 · 8 · 8이 달리 보였다.'),
        ],
        gives: ['co2Fact'],
      },
      {
        id: 'rumor',
        label: '수사본부의 의심',
        when: { flag: 'search' },
        lines: [
          say('ahn', '선배가 범인하고 한패라고요? …형사님도 그렇게 생각하세요?'),
          say('ahn', '선배는 부산 보고서를 고쳐 달라는 요청을 자기 손으로 올린 사람이에요. 사유서에 「제가 덜 봤습니다」라고 썼어요. 연구원에서 그런 사유서를 쓰는 사람은 처음 봤어요.'),
          say('ahn', '숨길 게 있는 사람이 그런 걸 써요?'),
        ],
      },
    ],
    present: {
      letter: {
        lines: [
          say('ahn', '이게 선배 동생분 글씨예요? 꾹꾹 눌러 썼네요. 선배는 날려 써요. 결재판에 서명한 걸 백 번은 봤어요. 형제인데 글씨가 하나도 안 닮았네요.'),
        ],
      },
      trail: {
        lines: [
          say('ahn', '서른 곳 명단이요? 제가 뽑아 드린 거 맞아요. 그게 동생분을 찾는 거였어요? …저는 논문 쓰시는 줄 알았어요.'),
        ],
      },
    },
    fallback: [say('ahn', '그건 제가 답할 수 있는 게 아닌 것 같아요.')],
  },
  {
    id: 'song',
    name: '송영만',
    age: 67,
    role: '유족회 대표',
    tag: '유족',
    loc: 'bereaved',
    desc: '한성물류센터 화재로 아내를 잃었다. 15년째 법원 앞에 선다. 봄에는 용의자였고, 지금은 수사본부가 아직 사과하러 오지 않은 사람이다.',
    topics: [
      {
        id: 'fifteen',
        label: '15주기',
        lines: [
          say('song', '15년이오. 그놈은 그날 잔치를 한답디다. 창립 30주년. 유족회에 초대장은 안 왔소.'),
          say('song', '날을 일부러 그날로 잡았겠소? 아니오. 그게 더 기가 막힌 거요. 그놈은 그날이 무슨 날인지를 모르는 거요.'),
        ],
      },
      {
        id: 'younger',
        label: '윤 선생의 작은아들',
        when: { clue: 'decoded' },
        lines: [
          me('봄에 윤 선생님 아들이 둘이라고 하셨죠. 작은아들 이름이 시호 맞습니까.'),
          say('song', '시호. 윤시호. 불났을 때 중학생이었소. 열여섯이었지.'),
          say('song', '재판 날마다 교복을 입고 맨 앞줄에 앉았소. 혼자서. 선고 나던 날, 법원 복도에서 그 애가 변호사 사무실 직원한테 탄원서 묶음을 좀 보자고 했소. 그 자리에 서서 한 장씩 넘겼지. 천 명 이름을 끝까지.'),
          say('song', '다 보고 나서 나한테 묻더이다. 「아저씨, 이 사람들은 다 알았을까요. 잠가 놓은 거.」'),
          say('song', '나는 대답을 못 했소. 알았겠지. 거기서 일하던 사람들인데. 그 애는 묶음을 나한테 넘겨주고 나갔고, 그 뒤로 유족회에는 발을 끊었소.'),
        ],
        gives: ['younger'],
      },
      {
        id: 'elder',
        label: '큰아들',
        when: { flag: 'search' },
        lines: [
          say('song', '큰애를 찾는다고? 허. 봄에는 나더니 이번엔 그 애요?'),
          say('song', '그 애, 10월에 여길 왔었소. 13년 만에. 얼굴이 반쪽이 돼서. 동생한테서 연락 온 게 없느냐고 묻더이다.'),
          say('song', '없다고 했더니 한참 저 사진 앞에 서 있다 갔소. 가면서 그랬소. 「아저씨. 재판 때 제가 걔 옆에 앉아 있었어야 했는데, 저는 서울에 있었어요.」'),
        ],
      },
    ],
    present: {
      petition: {
        lines: [
          say('song', '1,043명이오. 내가 세 번을 세어 봤소. 그중에 장례식장에 온 사람은 열이 안 되오.'),
        ],
      },
      letter: {
        lines: [
          say('song', '숫자는 나는 모르오. 그런데 이 글씨… 이렇게 꾹꾹 눌러 쓰는 건 윤 선생 버릇이었소. 칠판 글씨도 분필이 부러지게 눌러 썼다고, 그 집 애들이 그랬지.'),
        ],
      },
      invitation: {
        lines: [
          say('song', '7시 40분에 건배를 한다고? …우리는 7시 42분에 초를 켜오.'),
        ],
      },
      judgment: {
        lines: [
          say('song', '평택 냉동 창고. 아오. 유족회에서 조문을 갔소. 스물한 살짜리 영정 앞에 그 어머니가 앉아 있었지.'),
          say('song', '장례식장 복도 끝에 시호가 서 있더이다. 9년 만에 봤소. 들어오지는 않았소. 내가 다가가니까 그러더이다. 「아저씨, 저 거기 적어 놨어요. 경보 꺼져 있다고.」'),
          say('song', '그 말만 하고 갔소. 그해 가을에 표영달이 또 집행유예를 받았고.'),
        ],
      },
    },
    fallback: [say('song', '그런 건 나는 모르오.')],
  },
  {
    id: 'keeper',
    name: '오 주임',
    age: 54,
    role: '납골당 관리 직원',
    tag: '참고인',
    loc: 'vault',
    desc: '이 납골당에서 12년을 일했다. 누가 언제 오는지, 누가 안 오는지를 방명록보다 정확히 안다.',
    topics: [
      {
        id: 'younger',
        label: '해마다 오는 사람',
        lines: [
          say('keeper', '저 자리요? 해마다 12월 10일에 젊은 남자분이 와요. 문 닫기 30분 전에요. 모자 쓰고 마스크 하고, 흰 국화 두 송이를 들고.'),
          say('keeper', '말을 걸어 본 적은 없어요. 늘 10분쯤 서 있다가 방명록에 한 줄 쓰고 가요. 글씨를 참 꾹꾹 눌러 써요.'),
          say('keeper', '제가 일한 12년 동안 한 번도 안 빠졌어요. 눈이 무릎까지 온 해에도 왔어요.'),
        ],
      },
      {
        id: 'elder',
        label: '다른 방문객',
        lines: [
          say('keeper', '올해 8월부터는 다른 남자분이 와요. 키 크고 마른 분이요. 한 달에 한 번꼴로요. 그 전 12년 동안은 저 자리에 한 사람만 왔어요.'),
          say('keeper', '오면 방명록 마지막 장부터 봐요. 저한테 묻는 것도 늘 같아요. 모자 쓴 젊은 남자가 다녀갔느냐고.'),
          say('keeper', '12월 7일에는 문 닫을 때까지 저 의자에 앉아 있었어요. 흰 국화 두 송이를 들고 왔는데, 꽂지 않고 도로 들고 가더라고요.'),
        ],
      },
    ],
    present: {
      guestbook: {
        lines: [
          say('keeper', '앞쪽 장을 보면 처음 몇 해는 글씨가 둘이에요. 형제가 같이 왔나 봐요. 제가 온 뒤로는 늘 하나였어요.'),
        ],
      },
      letter: {
        lines: [
          say('keeper', '올해는 못 온다고요? …12년 동안 그런 해가 없었는데요.'),
        ],
      },
    },
    fallback: [say('keeper', '글쎄요, 그건 제가 모르겠네요.')],
  },
  {
    id: 'uncle',
    name: '윤태수',
    age: 64,
    role: '윤은호·윤시호의 삼촌',
    tag: '가족',
    loc: 'home',
    desc: '죽은 윤태준의 동생. 서해에서 철물점을 한다. 불이 난 뒤 6년 동안 조카 윤시호를 데리고 살았다. 수사본부의 전화를 받고 첫 버스로 올라왔다. 묻는 말에 짧게 대답한다.',
    topics: [
      {
        id: 'left',
        label: '2010년 겨울',
        lines: [
          say('uncle', '불나고 장례 치르고 나니 은호 대학 합격 통지가 왔소. 서울. 형님이 살아 계셨으면 동네에 떡을 돌렸을 거요.'),
          say('uncle', '은호는 안 간다고 했소. 시호를 두고 어떻게 가느냐고. 내가 가라고 했소. 시호는 내가 데리고 있겠다고.'),
          say('uncle', '2월에 은호가 올라갔소. 시호 중학교 졸업식 다음 날이었지. 시호는 터미널에 안 나왔소.'),
          say('uncle', '은호는 방학 때마다 내려왔소. 시호는 그때마다 독서실에 가 있었고. 재판도 시호 혼자 다녔소. 은호는 시험이라 못 오는 날이 많았고, 나는 가게를 못 비웠소.'),
        ],
        gives: ['leftBehind'],
      },
      {
        id: 'work',
        label: '윤시호가 하던 일',
        lines: [
          say('uncle', '고등학교 마치자마자 소방 설비 업체에 들어갔소. 대학은 안 간다고. 이유는 한 번 들었소. 스프링클러만 열려 있었어도 다 살았다는 말을 재판에서 들었다고.'),
          say('uncle', '일은 꼼꼼하게 했소. 그래서 세 번 잘렸소. 잘릴 때마다 우리 집에 와서 며칠 자고 갔지.'),
          say('uncle', '한 번은 밥 먹다가 묻더이다. 「삼촌, 제가 적은 게 틀렸어요?」 틀린 건 없다고 했소. 그 애는 더 묻지 않았소.'),
        ],
      },
      {
        id: 'last',
        label: '마지막으로 본 날',
        lines: [
          say('uncle', '2021년 10월 말이오. 저녁에 불쑥 왔소. 양복을 입고 있더이다. 어디 다녀오느냐니까 법원이라고.'),
          say('uncle', '밥 한 그릇 먹고, 자고 가라니까 됐다고 하고 나갔소. 그 뒤로 전화가 안 됐소. 은호한테는 해마다 문자가 한 통씩 온다고 들었고.'),
          say('uncle', '그리고 올라오기 전날 이게 왔소.'),
          n('삼촌이 점퍼 안주머니에서 누런 봉투를 꺼냈다. 보내는 사람은 없다. 소인은 12월 5일, 서울. 형에게 편지를 부친 날이다.'),
          n('안에는 5만 원권 묶음과 쪽지 한 장이 들어 있다. 꾹꾹 눌러 쓴 글씨다. 「삼촌. 6년 치 밥값입니다. 고마웠습니다. 시호.」'),
          n('삼촌은 봉투를 도로 넣지 못하고 두 손으로 들고 서 있었다.'),
        ],
        gives: ['parcel'],
      },
    ],
    present: {
      letter: {
        lines: [
          say('uncle', '시호 글씨요. …납골당을 형더러 가라고. 그 애는 15년 동안 누구한테 뭘 해 달라고 한 적이 없소.'),
        ],
      },
      fridge: {
        lines: [
          say('uncle', '형님이 애들 어릴 때 가르친 거요. 식구끼리만 아는 글자라고. 나는 끝내 못 외웠소.'),
        ],
      },
      unsent: {
        lines: [
          say('uncle', '…은호가 그리 썼소? 두고 간 게 아니오. 내가 보낸 거요.'),
        ],
      },
      noRecord: {
        lines: [
          say('uncle', '사진이라면 나한테도 고등학교 졸업식 것이 마지막이오. 그 뒤로는 찍자고 하면 자리를 떴소.'),
        ],
      },
    },
    fallback: [say('uncle', '그건 내가 모르는 일이오.')],
  },
  {
    id: 'ha',
    name: '하 센터장',
    age: 49,
    role: '인천 신물류센터장',
    tag: '참고인',
    loc: 'incheon',
    desc: '새 물류센터의 책임자. 준공식을 사흘 앞두고 경찰 예순 명을 맞게 됐다. 묻는 말마다 서류부터 내민다.',
    topics: [
      {
        id: 'safety',
        label: '안전 설비',
        lines: [
          say('ha', '여긴 하나도 안 껐습니다. 못 꺼요. 준공식에 기자가 예순 명 옵니다. 소방서 완공 검사도 지적 0건으로 통과했고요.'),
          say('ha', '회장님 지시입니다. 「인천은 보여 주는 곳이니까 원칙대로 해라.」'),
          me('보여 주는 곳이 아닌 데는요.'),
          say('ha', '…그건 제가 말씀드릴 수 있는 게 아닙니다.'),
        ],
      },
      {
        id: 'tech',
        label: '점검 기사',
        lines: [
          say('ha', '기사가 메모를 남겼느냐고요? 그런 건 없습니다. 기사한테 뭘 꺼 달라고 부탁한 적이 없으니까요.'),
          say('ha', '점검은 큰 업체 정직원들이 조를 짜서 옵니다. 명찰에 사진까지 박혀 있어요. 혼자 다니는 기사는 여기 못 들어옵니다.'),
        ],
      },
    ],
    present: {
      fifthNote: {
        lines: [
          say('ha', '본사 지하에요? …거긴 본사 방재팀 일입니다. 저는 모릅니다. 정말입니다.'),
        ],
      },
    },
    fallback: [say('ha', '그건 서류를 찾아봐야 합니다.')],
  },
  {
    id: 'byun',
    name: '변재만',
    age: 71,
    role: '한성그룹 회장',
    tag: '표적',
    loc: 'hansung',
    desc: '15년 전 한성물류의 대표. 재판받은 다섯 명 가운데 혼자 살아 있다. 문밖에 경호원 여섯이 서 있다. 자기가 표적이라는 것은 알지만, 왜 표적인지는 끝내 모르는 얼굴이다.',
    topics: [
      {
        id: 'cancel',
        label: '기념식 취소',
        lines: [
          say('byun', '취소하라고? 형사 양반. 두 번을 미뤘소. 6월에 한 번, 가을에 한 번. 경찰이 주워 온 편지 한 장에 세 번을 미루면 한성이 뭐가 되오.'),
          say('byun', '경호원이 여섯이오. 경찰도 깔린다며. 나는 그날 건배사를 할 거요.'),
        ],
      },
      {
        id: 'date',
        label: '12월 11일',
        lines: [
          me('회장님. 12월 11일이 무슨 날인지 아십니까.'),
          say('byun', '목요일이지. 내 일정이 비는 날이오. 비서실에서 잡았소.'),
          me('그것 말고는요.'),
          say('byun', '…송년회를 겸하는 거니까 연말이고. 뭘 묻는 거요?'),
          n('그는 정말로 모른다. 15년 전 그날 저녁, 자기 물류센터에서 아홉 명이 죽었다는 것을. 잊으려고 애쓴 얼굴이 아니다. 애쓸 필요도 없이 지워진 얼굴이다.'),
        ],
        gives: ['byunSays'],
      },
      {
        id: 'dead',
        label: '죽은 네 사람',
        lines: [
          say('byun', '넷이 죽었으니 다음은 나라는 거요? 그 사람들은 제 사업장 관리를 엉망으로 한 거요. 우리 그룹은 안전경영 대상을 받았소.'),
        ],
      },
    ],
    present: {
      petition: {
        lines: [
          say('byun', '이걸 아직 갖고 있는 사람이 있소? 고마운 사람들이지. 어려울 때 회사 편에 서 준 사람들이오. 그래서 이번에 다 불렀소.'),
          n('그는 그 종이를 훈장처럼 쓰다듬었다.'),
        ],
      },
      letter: {
        lines: [
          say('byun', '형제끼리 주고받은 편지를 왜 나한테 보이오. 납골당이라니, 누구 납골당이오.'),
        ],
      },
      fifthNote: {
        lines: [
          say('byun', '기사가 끄적인 메모를 회장이 봐야 하오? …봄에도 같은 걸 묻지 않았소?'),
          n('봄에도 그는 같은 대답을 했다. 그 뒤로 한 사람이 더 죽었다.'),
        ],
      },
    },
    fallback: [say('byun', '10분 다 됐소.')],
  },
  {
    id: 'chae',
    name: '채 과장',
    age: 38,
    role: '한성 총무팀',
    tag: '참고인',
    loc: 'hall',
    desc: '기념식 실무를 혼자 떠맡은 총무팀 과장. 좌석표, 명찰, 주차권. 묻는 말에는 뭐든 대답해 준다. 그 대답이 무슨 뜻인지 생각할 틈이 없어서다.',
    topics: [
      {
        id: 'guests',
        label: '초청 명단',
        lines: [
          say('chae', '천 명 명단은 회장님이 직접 고르셨어요. 근속 20년이 넘은 임직원, 그리고 창립 때부터 거래한 협력사 분들이요.'),
          say('chae', '회장님 표현으로는 「어려울 때 회사 편에 서 준 분들」이래요. 명단 원본 맨 위에 손글씨 메모가 있어요. 「2012년 탄원 명부 참조」.'),
          say('chae', '무슨 명부인지는 저는 몰라요. 비서실에서 받은 대로 초대장을 보냈어요.'),
        ],
        gives: ['guests'],
      },
      {
        id: 'way',
        label: '사람들이 나가는 길',
        lines: [
          say('chae', '나가는 길이요? 문을 나서면 로비고, 로비 양쪽 끝에 계단이 둘이에요. 지상까지 두 층을 올라가야 해요. 승강기는 행사 때 음식 나르느라 묶어 놔요.'),
          say('chae', '천 명이 다 빠지려면… 재작년에 재 봤는데 10분이 넘게 걸렸어요. 계단이 좁아서 로비에 줄이 길게 서요.'),
        ],
      },
      {
        id: 'crews',
        label: '드나드는 사람들',
        lines: [
          say('chae', '행사 준비로 하청이 다섯 군데 들어와 있어요. 무대, 조명, 음식, 청소, 그리고 소방 점검. 다 합치면 여든 명쯤 돼요.'),
          say('chae', '얼굴이요? 솔직히 몰라요. 다들 모자에 마스크라서요. 조끼 색으로 구분해요. 조명은 파랑, 청소는 연두, 소방은 주황.'),
          me('출입 대장은 있습니까.'),
          say('chae', '총무팀에 있어요. 이름하고 소속, 자격증 번호까지 받아 놔요. 한 부 뽑아 드릴게요.'),
        ],
      },
    ],
    present: {
      gasSystem: {
        lines: [
          say('chae', '저게 위험한 거예요? …철거하자는 기안이 한 번 올라갔다가 되돌아왔어요. 「안 쓰는 설비에 2억은 과하다」고요.'),
        ],
      },
    },
    fallback: [say('chae', '죄송해요, 그건 제 담당이 아니라서요.')],
  },
  {
    id: 'eom',
    name: '엄 팀장',
    age: 51,
    role: '본사 방재팀장',
    tag: '참고인',
    loc: 'control',
    desc: '본사 방재실을 9년째 맡고 있다. 나쁜 사람은 아니다. 위에서 끄라면 끄고, 민원이 들어오면 끄고, 꺼 둔 것을 잊어버리는 사람이다.',
    topics: [
      {
        id: 'system',
        label: '지하 2층의 가스 설비',
        lines: [
          say('eom', '컨벤션홀 가스 설비요? 살아 있죠. 소방 설비는 달려 있으면 살려 놔야 합니다. 그건 끄면 제가 처벌받아요.'),
          say('eom', '가스 저장실은 지하 3층입니다. 가스통이 마흔 개 서 있어요. 문은 방재팀 카드로만 열립니다. 보시겠다면 같이 내려가 드리죠.'),
          say('eom', '자세한 건 세이프텍 마 기사가 잘 알아요. 그 친구한테 직접 물어보세요.'),
        ],
      },
      {
        id: 'renovation',
        label: '연회장으로 고친 공사',
        lines: [
          say('eom', '전산센터 때는 그 방이 금고 같았어요. 가스가 한 줌도 안 새게 벽이고 천장이고 꽉 막아 놨죠. 가스가 새면 불이 안 꺼지니까요.'),
          say('eom', '연회장으로 고치면서 냉난방 통로를 벽에 여섯 군데 뚫었어요. 로비 천장하고 통해 있습니다. 사람 천 명이 들어가니까 바람은 넣어 줘야죠.'),
          me('그 상태에서 가스가 터지면요.'),
          say('eom', '…샙니다. 로비로, 계단으로요. 터질 때 미는 힘이 세거든요. 문을 닫으면 덜 새기는 하겠지만.'),
          say('eom', '그러니까 터질 일이 없어야죠. 터질 일은 없습니다. 불만 안 나면요.'),
        ],
        gives: ['ducts'],
      },
      {
        id: 'sub',
        label: '하청 업체',
        lines: [
          say('eom', '소방 유지보수는 하청입니다. 1년에 한 번씩 입찰해요. 싼 데가 됩니다.'),
          say('eom', '전에 하던 업체는 9월 말에 계약이 끝났어요. 10월부터는 세이프텍입니다. 마 기사가 석 달째 혼자 다 봐요. 손이 좋습니다.'),
          me('업체가 바뀌면 사람도 바뀝니까.'),
          say('eom', '그렇겠죠. 서류가 통째로 새로 들어오니까요. 저는 출입 등록 서류하고 자격증 사본을 받아서 철해 둡니다.'),
        ],
      },
    ],
    present: {
      fifthNote: {
        lines: [
          say('eom', '아, 그거. 9월에 전 업체 기사가 쓴 겁니다. 서명해 달라고 왔는데… 못 해 줬어요.'),
          me('왜요.'),
          say('eom', '서명하면 제가 봤다는 게 되잖아요. 봤으면 고쳐야 하고요. 철거 기안은 이미 한 번 되돌아왔어요. 위에서 「긁어 부스럼 만들지 말라」고 했습니다.'),
          say('eom', '그 기사가 나가면서 하나를 묻더군요. 「팀장님, 그 방에 사람이 몇 명 들어갑니까.」 천 명이라고 했더니 아무 말 없이 한 줄을 더 쓰고 갔어요.'),
        ],
      },
      cabinet: {
        lines: [
          say('eom', '커튼 뒤 조작함이요? 그 유리는 깨면 다칩니다. 옛날 유리라 날카롭게 갈라져요. 교체 품목에 올려는 놨는데.'),
        ],
      },
      basement: {
        lines: [
          say('eom', '공기호흡기가 한 벌뿐인 거요? …압니다. 구매 기안이 2년째 제 서랍에 있어요. 올리면 되돌아오고, 올리면 되돌아오고.'),
        ],
      },
    },
    fallback: [say('eom', '그건 기록을 찾아봐야 알겠는데요.')],
  },
  {
    id: 'tech',
    name: '마 기사',
    role: '세이프텍 하청 기사',
    tag: '참고인',
    loc: 'control',
    // He goes on his rounds after she asks him to step out, and is not seen there again.
    goneWhen: { flag: 'askedOut' },
    desc: '10월부터 본사 소방 설비를 혼자 돌보는 하청 기사. 방재실에 들를 때마다 수신기 함 안에 상체를 넣고 일하고 있어서 주황 조끼의 등과 작업 장갑만 보인다. 묻는 말에는 손을 멈추지 않고 대답한다.',
    topics: [
      {
        id: 'switch',
        label: '가스 설비가 터질 때',
        lines: [
          me('지하 2층 가스 설비가 작동하면 어떻게 됩니까. 순서대로요.'),
          say('tech', '감지기 둘이 같이 울리면 수신기가 불이라고 판단합니다. 그러면 홀에 경보가 울리고 시계가 돕니다. 이 건물은 30초로 맞춰져 있습니다.'),
          say('tech', '30초 뒤에 저장실의 밸브가 열리고, 천장의 분사구 스물네 개에서 가스가 한꺼번에 나옵니다. 1분이면 방이 찹니다.'),
          me('30초 안에 못 나가면요.'),
          say('tech', '그래서 조작함에 방출 지연 단추가 있습니다. 정문 안쪽, 커튼 뒤에요. 그 단추는 누르고 있는 동안만 시계를 멈춥니다. 손을 떼면 시계는 멈췄던 데서 다시 갑니다.'),
          say('tech', '눌러서 끄는 단추가 아닙니다. 붙잡고 있는 단추입니다. 사람이 다 나갈 때까지 누가 거기 서 있어야 한다는 뜻이죠.'),
          say('tech', '그런 함은 보통 문 바깥에 답니다. 누르던 사람도 손을 떼고 바로 피할 수 있게요. 여기는 공사하면서 안으로 들어가 버렸습니다만.'),
          me('다른 방법으로는 못 멈춥니까.'),
          say('tech', '저장실에서는 됩니다. 거기에 이 설비만 따로 켜고 끄는 제어반이 있습니다. 열쇠를 정지로 돌리면 전부 멈춥니다. 반대로 그 옆의 수동 레버를 당기면 시계고 뭐고 없이 바로 나갑니다. 그때는 지연 단추도 소용없습니다.'),
          n('낮고 차분한 목소리다. 설명에 막힘이 없다. 함 안에서 드라이버 돌아가는 소리가 계속 났다.'),
        ],
        gives: ['delaySwitch'],
      },
      {
        id: 'face',
        label: '잠깐 나와 달라고 한다',
        when: { clue: 'delaySwitch' },
        lines: [
          me('기사님. 잠깐 나와서 얘기할 수 있을까요.'),
          say('tech', '죄송합니다. 지금 전기가 살아 있는 선을 잡고 있어서 손을 못 뗍니다. 떼면 건물 전체에 경보가 울립니다.'),
          say('eom', '아이고, 그건 안 됩니다, 형사님. 지금 위에서 임원 회의 중이에요.'),
          say('tech', '30분쯤 걸립니다. 기다리시겠습니까.'),
          me('30분 뒤에 다시 오겠습니다.'),
          n('그사이 지하 2층을 한 바퀴 더 돌았다. 30분 뒤에 돌아왔을 때 수신기 함의 문은 닫혀 있었다.'),
          say('eom', '마 기사요? 방금 내려갔어요. 지하 3층부터 옥상까지 도는 시간이라서요. 다 돌면 두 시간입니다. 하청 기사들은 시간표대로 움직여요.'),
          n('나는 엄 팀장에게 그 기사의 출입 등록 서류를 한 부 달라고 했다. 모자와 마스크 사이로 눈을 한 번 보는 것보다 그쪽이 빠르고 확실하다.'),
          n('방재실을 나서며 닫힌 함을 돌아봤다. 조끼를 입은 등, 작업 장갑, 안전화. 봄부터 여덟 달을 찾아다닌 사람도 그런 차림이었다. 그리고 오늘 이 건물에서 마주친 하청 인력 수십 명이 전부 그런 차림이다.'),
        ],
        flag: 'askedOut',
      },
      {
        id: 'off',
        label: '수신기의 주황 불',
        lines: [
          say('tech', '차단 열일곱 개요. 제가 오기 전부터 그랬습니다.'),
          say('tech', '하나씩 되살리자고 말씀은 드렸습니다. 끄는 건 전화 한 통이면 되는데, 켜는 건 결재가 석 달 걸립니다.'),
          say('tech', '꺼 두면 안 울립니다. 안 울리면 고장도 없고 민원도 없습니다. 사고가 나기 전까지는 그게 제일 편한 상태입니다.'),
        ],
      },
    ],
    present: {
      fifthNote: {
        lines: [
          me('9월 점검표에 이런 메모가 있습니다. 「철거 요망. 관리자 서명 거부.」'),
          say('tech', '…반듯한 글씨죠.'),
          n('그는 고개를 내밀지 않았다. 내 손의 종이를 보지도 않았다. 점검표 철은 석 달째 그의 손이 닿는 선반에 꽂혀 있었으니, 벌써 읽었을 것이다.'),
          say('tech', '서명을 못 받으면 그렇게라도 적어 둡니다. 내가 말했다는 걸 남기는 거죠. 기사가 할 수 있는 건 거기까지라서요.'),
          me('9월이면 세이프텍이 들어오기 전입니다. 그때 기사를 압니까.'),
          say('tech', '모릅니다. 이 일은 업체가 바뀌면 서로 얼굴도 못 봅니다.'),
        ],
      },
      letter: {
        lines: [
          say('tech', '편지요? 지금은 손이 묶여서 못 봅니다. 죄송합니다.'),
        ],
      },
    },
    fallback: [say('tech', '그건 팀장님께 물어보시는 게 빠릅니다.')],
  },
  {
    id: 'light',
    name: '도 기사',
    role: '조명 하청 기사',
    tag: '참고인',
    loc: 'hall',
    desc: '기념식 조명을 다는 하청 업체의 기사. 사다리 꼭대기에서 천장 격자 속에 상체를 넣고 일하고 있어서 파란 조끼의 등과 안전화 밑창만 보인다. 묻는 말에는 천장 속에서 대답이 내려온다.',
    topics: [
      {
        id: 'above',
        label: '천장 속',
        lines: [
          say('light', '천장 속이요? 전선 다발하고 먼지죠. 붉은 배관은 저희 것 아닙니다. 소방 쪽 거라고, 건드리지 말고 피해서 달라고 들었어요.'),
          say('light', '나팔처럼 생긴 쇠 주둥이가 조명 자리마다 걸려서 애먹습니다. 스물네 개를 전부 피해서 달았어요.'),
          say('light', '소방 기사님이 가끔 올라와서 그 배관만 보고 가요. 말수가 없는 분이라 인사만 합니다.'),
        ],
      },
      {
        id: 'down',
        label: '잠깐 내려와 달라고 한다',
        lines: [
          me('기사님. 잠깐 내려와 주시겠습니까.'),
          say('light', '지금요? 이 등 하나만 걸고요.'),
          n('2분 뒤에 그가 사다리를 내려왔다. 모자에 마스크. 마스크 위로 눈만 나와 있다. 그는 마스크를 턱으로 내리고 물을 마셨다. 서른 중반의 평범한 얼굴이다.'),
          n('봄에 음성의 정문에서 본 눈인가. 모르겠다. 여덟 달 전, 차창 너머로 1초 본 눈이다. 모자와 마스크 사이로 눈만 내놓은 얼굴은 누구든 서로 닮아 보인다.'),
          me('출입증 좀 보겠습니다.'),
          say('light', '출입증이요? 여기요. 저희는 이번 행사 때문에 나흘만 들어오는 업체라 총무팀에서 임시로 끊어 줬어요.'),
          n('출입증의 이름과 번호를 수첩에 적었다. 얼굴을 한 번 본다고 알 수 있는 것이 아니다. 조회에 넣을 수 있는 것은 이름이다.'),
        ],
      },
    ],
    present: {
      gasSystem: {
        lines: [
          say('light', '그게 가스 나오는 거였어요? …저는 그 밑에서 사흘을 일했는데요.'),
        ],
      },
    },
    fallback: [say('light', '그건 저는 모르겠습니다. 총무팀에 물어보세요.')],
  },
];

// Notebook entries that only appear once the player has learned of them.
export const EXTRAS = [
  {
    when: { flag: 'search' },
    name: '윤은호',
    age: 33,
    role: '국과수 연구관 · 휴직 중',
    tag: '소재 불명',
    desc: '화재와 안전사고의 원인을 조사하던 사람. 4월에 전선의 숫자를 읽고도 말하지 않았다. 6월 말의 메시지를 마지막으로 연락이 끊겼고 8월에 휴직했다. 수사본부는 그를 동생과 한패로 보고 찾고 있다.',
  },
  {
    when: { clue: 'decoded' },
    name: '윤시호',
    age: 30,
    role: '소방 설비 기사',
    tag: '범인',
    desc: '윤은호의 세 살 아래 동생. 불이 났을 때 중학교 3학년이었다. 네 현장에 메모를 남긴 그 기사다. 4년 전부터 어떤 서류에도 없다. 지금의 얼굴을 아는 사람이 없다.',
  },
];

// Each plays once, on the first move after its conditions are met.
export const EVENTS = [
  {
    id: 'search',
    cluesAtLeast: 3,
    when: { clue: 'yun' },
    lines: [
      n('문 대장에게 보고했다. 편지의 숫자, 그리고 모니터의 메모지. 5분이 걸렸다.'),
      say('moon', '그러니까 그 기사가 윤은호의 동생이고, 전선마다 붙은 숫자가 그 집 성이고, 윤은호는 4월에 그걸 읽었다.'),
      me('네.'),
      say('moon', '읽고도 여덟 달을 입 다물었어. 8월에는 휴직하고 전화기를 껐고. 그리고 동생은 형한테 편지를 썼어. 날짜하고 가스 이름까지 적어서.'),
      say('moon', '「올해 납골당은 형이 가.」 뒷일을 맡긴다는 소리야. 형제가 같이 하는 일이야. 적어도 형은 알고 덮었어.'),
      me('편지는 뜯기지 않은 채 우편함에 있었습니다. 윤은호는 그 편지를 읽지 못했습니다.'),
      say('moon', '집이 아니라 연구원으로 보낸 걸 보면 동생도 형이 어디 있는지 모른다는 거지. 그건 인정해. 하지만 4월에 읽고 말 안 한 건 그대로야.'),
      say('moon', '오늘부로 윤은호를 찾는다. 통신, 카드, 차량 전부. 집도 영장을 받아서 연다. 서해에 삼촌이 있다니 가족으로 불러서 지켜보게 하고. 서 경위가 가.'),
      say('moon', '원칙대로면 서 경위는 이 사건에서 빼야 해. 그런데 그 집 숫자를 읽는 사람이 수사본부에 서 경위 하나야. 그래서 안 뺀다.'),
      say('moon', '대신 윤은호한테서 연락이 오면 그 즉시 나한테 보고해. 약속해.'),
      me('보고하겠습니다.'),
      n('약속은 지킬 것이다. 그리고 나는 윤은호가 넉 달 동안 무엇을 했는지 확인할 것이다.'),
    ],
  },
  {
    id: 'car',
    cluesAtLeast: 7,
    lines: [
      n('자리를 옮기는 차 안. 곽 경사가 한참 말없이 운전하다가 물었다.'),
      say('kwak', '서 경위. 4월에 윤 연구관이 그 라벨 보던 날 말이야. 정말 아무 말도 안 했어?'),
      me('놓쳤다고 했어요. 넉 달 전에 못 본 걸 이제야 봤다는 말인 줄 알았어요. 며칠 뒤에는 시간을 달라고 했고요. 확인해 볼 데가 있다고요.'),
      say('kwak', '그게 동생이었네.'),
      me('네.'),
      say('kwak', '…화나?'),
      me('나요.'),
      n('곽 경사는 고개를 끄덕였다. 더 묻지 않았다. 다음 휴게소에서 그는 따뜻한 캔커피를 하나 사서 내 무릎에 올려놓았다.'),
    ],
  },
  {
    id: 'sighting',
    cluesAtLeast: 14,
    when: { clue: 'schedule' },
    lines: [
      n('새벽 두 시. 전화가 울렸다. 문 대장이다.'),
      say('moon', '서 경위. 자는 거 깨워서 미안한데, 지금 들어.'),
      say('moon', '어젯밤 11시 12분, 한성 본사 지하 3층 CCTV에 윤은호가 찍혔어. 작업 조끼를 입고, 가스 저장실이라는 방 문 앞에.'),
      say('moon', '12월 11일에 회장이 가는 두 곳 중 한 곳이야. 거기를 이틀 전 밤에 형이 둘러봤어. 형제가 같이 움직인다는 내 생각은 더 굳었어.'),
      me('…영상을 보겠습니다.'),
      say('moon', '봐. 그 문은 못 열고 돌아갔어. 방재팀 카드가 없으면 안 열리는 문이래. 그러니 불을 낼 데는 여전히 인천이고, 저녁 본사에서는 그 얼굴만 찾으면 돼.'),
      say('moon', '보고 나서 생각이 다르면 증거를 들고 와.'),
      n('전화를 끊고도 한참 천장을 봤다. 윤은호가 살아 있다. 서울에 있다.'),
    ],
  },
  {
    id: 'eve',
    cluesAtLeast: 30,
    lines: [
      n('12월 10일 밤. 내일 아침 일곱 시에 수사본부에서 마지막 회의가 있다. 오늘 밤은 아무도 집에 가지 않는다.'),
      n('납골당에는 오늘 형사 넷이 문 열 때부터 닫을 때까지 서 있었다. 15년 동안 이날마다 오던 윤시호는 오지 않았다. 윤은호도 오지 않았다.'),
      n('작년 이 밤, 나는 과학관 옥상에서 목성을 보고 있었다. 옆에서 윤은호가 초점을 맞춰 주고 있었다.'),
      n('그 뒤로 토요일이면 거의 그 옥상에 올라갔다. 마지막은 4월 5일이다. 벤치에서 일어서면서 윤은호가 물었다. 「다음 주도 올 거죠.」 나는 「올게요」라고 했다.'),
      n('다음 주 토요일에 나는 음성에 있었다.'),
      n('곽 경사가 박카스 한 병을 내 책상에 놓고 갔다. 아무 말도 하지 않았다.'),
    ],
  },
];

export const DEDUCTION = {
  // The deduction opens once the player holds an accepted clue for every evidence step;
  // this list supplies the hint for the first step that still has none.
  required: [
    { clue: 'co2Fact', hint: '먼저 수사본부에서 편지의 숫자를 읽어야 한다. 그다음, 6 · 8 · 8이 어디에 쓰이는 가스인지 국과수의 안 연구사에게 물어보자.' },
    { clue: 'gasSystem', hint: '12월 11일에 회장이 가는 한성 본사. 지하 컨벤션홀의 천장을 아직 올려다보지 않았다.' },
    { clue: 'incheonClean', hint: '수사본부에서 12월 11일의 일정을 찾으면 후보지가 둘 나온다. 그중 인천 신물류센터, 방재실의 점검표를 봐야 한다.' },
    { clue: 'fifthNote', hint: '한성 본사 지하 컨벤션홀의 천장을 보고 나면 방재실에 갈 수 있다. 그곳의 점검표 철을 넘겨 봐야 한다.' },
    { clue: 'petition', hint: '유족회의 송영만에게 윤 선생의 작은아들에 대해 묻고, 그가 꺼내 주는 서류 묶음을 직접 봐야 한다.' },
    { clue: 'unsent', hint: '윤은호가 넉 달 동안 무엇을 했는지 아직 모른다. 그의 집 거실 벽에서 시작해, 바닥의 서류철을 끝까지 넘겨 봐야 한다.' },
  ],
  opening: [
    n('12월 11일 목요일, 아침 일곱 시. 수사본부 회의실.'),
    n('벽에는 배치표가 두 장 붙어 있다. 오전 인천 신물류센터, 저녁 한성 본사. 형사 예순 명의 이름은 두 장에 똑같이 적혀 있다.'),
    n('인천의 표에는 「소화기 · 대피로 · 불씨 단속」이 적혀 있다. 본사의 표에는 「회장 둘레 · 출입구 · 윤은호 전단」뿐이다. 그 건물의 천장과 지하 3층은 어느 칸에도 없다.'),
    say('moon', '세 시간 뒤에 인천에서 준공식이야. 그놈이 뭘 한다면 거기서 불로 한다. 저녁 본사에서는 형의 얼굴만 찾으면 돼. 배치는 끝났어. 서 경위가 할 말이 있다고 해서 5분 준다.'),
    me('인천이 아닙니다. 저녁의 본사입니다. 그리고 윤은호는 동생과 한패가 아닙니다. 순서대로 보여 드리겠습니다.'),
  ],
  wrong: [
    n('…아니다. 이것으로는 배치표를 바꿀 수 없다.'),
    say('moon', '서 경위. 시간 없어.'),
  ],
  steps: [
    {
      type: 'evidence',
      label: '범인이 쓰려는 것이 불이 아니라는 증거를 제시하라',
      prompt: [say('moon', '편지의 6 · 8 · 8은 이산화탄소. 불이 나면 나오는 가스지. 15년 전처럼 물류센터에 불을 내서 연기로 죽이겠다는 거야. 그래서 인천이고, 그래서 오전이야.')],
      accept: ['co2Fact', 'gasSystem'],
      near: {
        decoded: [n('6 · 8 · 8이 이산화탄소라는 것은 대장도 안다. 그 가스가 불 말고 어디에서 나오는지를 보여 줘야 한다.')],
        letter: [n('편지는 대장도 백 번을 봤다. 그 가스가 불 말고 어디에서 나오는지를 보여 줘야 한다.')],
        fifthNote: [n('이 메모는 장소를 말할 때 낼 것이다. 지금은 이 가스가 불 말고 어디에 쓰이는지부터 보여 줘야 한다.')],
        cabinet: [n('조작함은 그 설비에 딸린 물건이다. 먼저 그 설비가 무슨 가스로 무엇을 하는지를 보여 줘야 한다.')],
        delaySwitch: [n('터지는 순서는 나중 이야기다. 먼저 그 설비가 무슨 가스로 무엇을 하는지를 보여 줘야 한다.')],
      },
      success: [
        me('이 범인은 한 번도 제 손으로 불을 붙인 적이 없습니다. 늘 그 자리에 이미 달려 있던 장치를 썼습니다. 누전차단기, 승강기 문, 히터, 질소 탱크.'),
        me('이산화탄소는 불에서만 나오는 가스가 아닙니다. 불을 끄는 설비에 쓰는 가스입니다. 방 하나를 가스로 채워 산소를 밀어내는 설비입니다. 그 방에 사람이 있으면 몇 번 숨에 쓰러집니다.'),
        me('편지는 불을 내겠다는 말이 아닙니다. 불 끄는 설비를 사람한테 쓰겠다는 말입니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '다음 장소가 인천이 아니라는 증거를 제시하라',
      prompt: [say('moon', '그런 설비가 인천에 없으란 법 있어? 새로 지은 물류센터야. 없는 설비가 없을걸.')],
      accept: ['incheonClean'],
      near: {
        schedule: [n('일정표는 후보가 둘이라는 것만 말해 준다. 인천에 무엇이 없는지를 보여 줘야 한다.')],
      },
      success: [
        me('인천의 점검표입니다. 석 달 치가 전부 지적 사항 없음입니다. 스프링클러는 열려 있고 비상구도 열려 있습니다. 방을 이산화탄소로 채우는 설비는 그 건물에 없습니다.'),
        me('무엇보다 메모가 없습니다. 이 범인은 네 번 모두 먼저 경고를 남겼습니다. 꺼 달라는 사람이 있었고, 꺼진 장치가 있었고, 그 옆에 그의 글씨가 있었습니다.'),
        me('인천에는 꺼 달라고 한 사람이 없습니다. 그가 벌줄 사람이 없는 곳입니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '다음 장소가 한성 본사 지하라는 증거를 제시하라',
      prompt: [say('moon', '그럼 본사에는 그게 있다는 거지. 그 메모가. 다들 보게 내놔.')],
      accept: ['fifthNote'],
      near: {
        gasSystem: [n('설비가 남아 있다는 것만으로는 모자란다. 범인이 그 설비를 봤고, 경고했고, 거절당했다는 흔적이 필요하다.')],
        cabinet: [n('설비가 남아 있다는 것만으로는 모자란다. 범인이 그 설비를 봤고, 경고했고, 거절당했다는 흔적이 필요하다.')],
        invitation: [n('안내문은 그날 그곳에 사람이 모인다는 것만 말해 준다. 범인이 그곳을 골랐다는 흔적이 필요하다.')],
        cctv: [n('이 영상에 찍힌 사람은 형이다. 그리고 대장은 그 문이 안 열렸다는 데서 생각을 멈췄다. 범인 본인이 그 건물에 남긴 흔적을 내야 한다.')],
        delaySwitch: [n('설비가 어떻게 터지는지만으로는 모자란다. 범인이 그 설비를 봤고, 경고했고, 거절당했다는 흔적이 필요하다.')],
        ducts: [n('벽이 뚫렸다는 것만으로는 모자란다. 범인이 그 설비를 봤고, 경고했고, 거절당했다는 흔적이 필요하다.')],
        basement: [n('지하 3층에 무엇이 있는지만으로는 모자란다. 범인이 그 설비를 봤고, 경고했고, 거절당했다는 흔적이 필요하다.')],
      },
      success: [
        me('본사 방재실의 9월 점검표입니다. 「지하 2층 컨벤션홀은 옛 전산센터임. 이산화탄소 소화설비가 그대로 남아 있음. 사람이 모이는 곳에 둘 수 없는 설비임. 철거 요망. 관리자 서명 거부.」'),
        me('편지와 같은 글씨입니다. 다섯 번째 메모입니다.'),
        me('그 홀은 5년 전까지 전산센터였습니다. 천장에 분사구 스물네 개가 그대로 달려 있고, 설비는 지금도 살아 있습니다. 오늘 저녁 7시, 그 방에 천 명이 들어갑니다.'),
        n('회의실이 조용해졌다. 누군가 배치표에서 손을 뗐다.'),
      ],
    },
    {
      type: 'evidence',
      label: '범인이 그 천 명을 노리는 이유를 제시하라',
      prompt: [say('moon', '…잠깐. 이놈은 지금까지 재판받은 다섯 명만 골랐어. 한 번에 한 명씩. 그런 놈이 왜 갑자기 천 명이야. 변재만 하나를 노린다면 몰라도.')],
      accept: ['petition'],
      near: {
        memorial: [n('7시 42분은 그가 고를 시각일 것이다. 지금 묻는 것은 시각이 아니라 사람이다. 왜 그 천 명인가.')],
        byunSays: [n('회장이 그날을 잊었다는 것은 회장을 노릴 이유다. 나머지 천 명을 노릴 이유는 따로 있다.')],
        younger: [n('그 아이의 물음이 누구를 향했는지를 종이로 보여 줘야 한다. 그 아이가 선고 날 넘겨 본 묶음이다.')],
        invitation: [n('안내문은 천 명이 누구인지를 말해 준다. 그 천 명이 13년 전에 무엇을 했는지를 보여 줘야 한다.')],
        guests: [n('명단의 메모는 그 천 명이 어느 명부에서 왔는지를 가리킨다. 그 명부를 직접 내놓아야 한다. 유족회에 사본이 있다.')],
        reports: [n('이 서류철은 그가 어떤 사람이었는지를 말해 준다. 왜 그 천 명인지는 다른 종이가 말한다.')],
        judgment: [n('이 판결문은 그가 왜 서류에서 사라졌는지를 말해 준다. 왜 그 천 명인지는 13년 전의 다른 종이가 말한다.')],
      },
      success: [
        me('2012년 재판 때 법원에 들어간 탄원서입니다. 변재만 대표를 선처해 달라고 한성 임직원과 협력사 1,043명이 서명했습니다. 판결문은 그것을 참작한다고 썼습니다.'),
        me('오늘 기념식에 초대받은 천 명은 근속 20년이 넘은 임직원과 창립 때부터의 협력사입니다. 안내문에는 「어려울 때 한성의 곁을 지켜 주신 분들」이라고 적혀 있습니다. 13년 전 이 종이에 이름을 쓴 사람들입니다.'),
        me('윤시호는 선고 날 법원 복도에서 이 묶음을 첫 장부터 끝 장까지 넘겨 봤습니다. 고등학교 2학년 때입니다. 다 보고 나서 유족회 대표에게 물었습니다. 「이 사람들은 다 알았을까요. 잠가 놓은 거.」'),
        me('앞의 죽음들은 한 사람씩이었고, 서류에는 사고라고 적혔습니다. 그 뒤로 달라진 것은 없습니다. 천 명이 한 방에서 죽는 일은 누구도 사고라고 적을 수 없습니다.'),
        say('moon', '…그 천 명이 한 방에 모이는 날이 오늘이라는 거군.'),
      ],
    },
    {
      type: 'evidence',
      label: '윤은호가 동생을 돕는 것이 아니라 찾고 있다는 증거를 제시하라',
      prompt: [
        say('moon', '방은 알겠어. 이제 사람이야. 편지를 쓴 건 동생이고 받는 건 형이야. 형은 4월에 그 숫자를 읽고도 여덟 달을 입 다물었어.'),
        say('moon', '그제 밤 11시에는 본사 지하 3층 가스 저장실 문 앞에 찍혔고. 동생이 설비를 만지고 형이 뒤를 봐 주는 거야. 아니라면 그걸 보여 줘.'),
      ],
      accept: ['unsent'],
      near: {
        brotherNote: [n('형이 동생을 부르는 줄이다. 대장은 이것을 한패끼리 주고받는 연락으로 읽을 것이다. 윤은호가 왜 혼자 찾아다니는지를 그의 말로 보여 줘야 한다.')],
        tracing: [n('벽의 명단은 윤은호가 무엇을 했는지를 보여 준다. 왜 수사본부에 말하지 않고 혼자 했는지는 다른 종이에 적혀 있다. 그 벽 아래 서류철의 맨 뒤다.')],
        reports: [n('이것은 동생이 살아온 기록이다. 그것을 모은 형이 무슨 생각이었는지는 같은 서류철 맨 뒤에 있다.')],
        judgment: [n('이것은 동생이 살아온 기록이다. 그것을 모은 형이 무슨 생각이었는지는 같은 서류철 맨 뒤에 있다.')],
        cctv: [n('대장은 이 영상을 미리 둘러본 것으로 본다. 화면만으로는 어느 쪽인지 가릴 수 없다.')],
        letter: [n('이것은 동생이 쓴 편지다. 형이 무엇을 하고 있는지는 형이 쓴 것으로 보여 줘야 한다.')],
        leave: [n('휴직계의 네 글자는 대장에게 「사라졌다」는 뜻일 뿐이다. 사라져서 무엇을 했는지를 보여 줘야 한다.')],
        trail: [n('안 연구사의 말은 전해 들은 것이다. 윤은호가 직접 쓴 것이 필요하다.')],
        room: [n('비워 둔 방은 형의 마음을 말해 준다. 대장이 묻는 것은 마음이 아니라 넉 달 동안 한 일이다.')],
        yun: [n('이것은 대장이 든 근거다. 알고도 말하지 않은 까닭을 보여 줘야 한다.')],
        guestbook: [n('이것은 동생이 남긴 흔적이다. 형이 무엇을 하고 있는지를 보여 줘야 한다.')],
        leftBehind: [n('삼촌의 말은 15년 전의 일이다. 대장이 묻는 것은 윤은호가 지난 넉 달 동안 무엇을 했느냐다.')],
        searchOrder: [n('이것은 대장이 쓴 문서다. 여기에 맞설 것을 내야 한다.')],
      },
      success: [
        me('윤은호의 집을 수색해서 나온 편지입니다. 7월 31일 자, 휴직 전날입니다. 저한테 쓰고 부치지 않았습니다.'),
        me('「4월에 그 숫자를 봤을 때 알았습니다.」 대장님 말씀대로입니다. 알고도 말하지 않았습니다. 그 까닭도 적혀 있습니다. 「찾으면 총을 든 사람들이 걔 앞에 설 겁니다.」 「두고 간 사람이 저니까 데려오는 것도 제가 해야 합니다.」'),
        me('이 편지는 서류철 맨 뒤에 끼워져 있었습니다. 그 서류철에는 윤시호가 7년 동안 쓴 점검표 스물세 장과 2021년의 판결문이 들어 있습니다. 윤은호가 넉 달 동안 모은 것입니다. 한패라면 동생이 어디서 어떻게 일했는지를 종이로 찾아다닐 까닭이 없습니다.'),
        me('그리고 동생의 편지는 뜯기지 않은 채 우편함에 있었습니다. 동생은 형이 어디 있는지 모르고, 형은 동생이 어디 있는지 모릅니다.'),
        n('문 대장은 편지를 두 번 읽었다. 읽는 동안 회의실의 누구도 말하지 않았다.'),
        say('moon', '알고도 말 안 한 건 그대로야. 그건 나중에 따로 묻는다.'),
        say('moon', '하지만 한패는 아니네. 혼자 찾아서 혼자 데려오겠다는 거야.'),
      ],
    },
    {
      type: 'choice',
      label: '윤시호는 오늘 밤 일을 치른 뒤 어떻게 할 생각인가',
      prompt: [say('moon', '그럼 동생. 일을 치르고 어디로 빠질 것 같나. 주차장 경사로, 하역장, 계단. 나가는 길목마다 사람을 세워야 해.')],
      options: [
        { id: 'run', label: '하청 인력 사이에 섞여 빠져나간다. 네 번을 그렇게 했다' },
        { id: 'court', label: '스스로 잡힌다. 법정에서 말하려고' },
        { id: 'stay', label: '빠져나가지 않는다. 그 건물에서 죽을 생각이다' },
      ],
      accept: ['stay'],
      rebuttal: {
        run: [n('아니다. 앞의 네 번은 그렇게 빠져나갔다. 하지만 이번에는 형에게 편지를 썼다. 「올해 납골당은 형이 가. 나는 못 가.」 빠져나갈 사람은 내년 기일을 남에게 넘기지 않는다.')],
        court: [n('아니다. 법정에서 말하려는 사람은 4년 동안 제 이름을 서류에서 지우고 살지 않는다. 그리고 편지에는 「찾지 마」라고 적혀 있다.')],
      },
      success: [
        me('빠져나가지 않습니다. 편지에 적혀 있습니다. 「올해 납골당은 형이 가. 나는 못 가.」'),
        me('15년 동안 해마다 혼자 간 사람입니다. 올해 하루 못 간다는 말이 아닙니다. 이제부터는 형이 가라는 말입니다. 그리고 「찾지 마」.'),
        me('4년 전에 휴대폰을 끊고 계좌를 닫았습니다. 돌아갈 자리를 남겨 두지 않았습니다. 그는 오늘 밤 그 건물에서 죽을 생각입니다.'),
        me('그러니 길목을 지켜도 그는 나오지 않습니다. 끝까지 그 설비 곁에 있을 겁니다. 겁을 줘서 물러나게 할 수도 없습니다.'),
        say('moon', '…알았어. 길목에 세우려던 사람들은 그 홀 둘레로 돌린다.'),
        say('moon', '인천은 10시야. 회장이 거기 서는 이상 비울 수는 없어. 오전에는 예정대로 예순 명이 인천에 선다. 끝나는 대로 전원 본사로 넘어간다.'),
        say('moon', '저녁 배치는 다시 짠다. 회장 둘레만 볼 게 아니라 그 홀을 본다. 회장한테는 내가 다시 말한다. 식을 미루든 지상으로 옮기든 하라고.'),
        say('moon', '서 경위하고 곽 경사는 지금 본사로 가. 방재팀을 시켜서 지하 가스 설비를 오늘 낮에 잠가. 잠그는 걸 곽 경사가 지켜보고 사진으로 남겨.'),
        say('moon', '윤은호는 계속 찾는다. 다만 전단에서 「공범」은 뺀다. 보이면 나한테 데려와. 동생을 제일 잘 아는 사람이 그 사람이야.'),
        me('알겠습니다.'),
      ],
    },
    // The evening of December 11: one wrong move here ends it.
    {
      type: 'choice',
      stage: '결전',
      sudden: 'disaster',
      label: '천 명을 어떻게 내보낼 것인가',
      brief: '저녁 7시 42분, 지하 2층 컨벤션홀. 가스가 나오기까지의 시계는 7초를 남기고 멈춰 있다. 곽 경사가 단추를 누르고 있다. 문 넷이 전부 잠겼다. 문마다 옆 벽에 초록색 비상 개방 상자가 있다.',
      prompt: [
        n('오전 10시, 인천의 준공식은 아무 일 없이 끝났다.'),
        n('낮 두 시, 한성 본사 지하 3층 가스 저장실. 이 건물의 소방 점검을 맡은 하청 기사, 마 기사가 들어가 밸브를 잠갔다. 엄 팀장과 곽 경사가 문간에서 지켜봤고, 곽 경사가 사진을 찍었다.'),
        n('본사에 드나드는 하청 인력 여든세 명의 조회는 이미 끝나 있었다. 소방 점검은 세이프텍의 마동수, 쉰두 살. 부천 집에 전화를 넣자 부인이 남편은 본사 현장에 나가 있다고 했다. 마 기사는 여느 날처럼 주황 조끼에 모자와 마스크 차림이었다. 가스통 사이가 좁아서 두 사람은 문간에 서서 봤다.'),
        n('사진에는 앞줄 가스통의 밸브마다 붉은 잠금핀이 꽂혀 있다. 방재실 수신기의 그 칸에는 「정지」가 떴다.'),
        n('오후 세 시, 나는 저장실 문에 경찰 봉인지를 붙이러 지하 3층에 내려갔다. 계단문을 나서면 주차장이다. 문 옆 벽에 회색 조작반이 있다. 단추가 둘. 「주차장·기계실 배기팬」, 「경사로 셔터」. 배기팬은 지하 3층의 공기를 빨아 지상으로 내보낸다. 차가 오르내리는 경사로의 셔터는 행사 때문에 내려져 있었다. 조작반 옆에는 불 끄는 호스가 말려 든 붉은 소화전함.'),
        n('저장실은 거기서 계단 열 단을 더 내려간 기계실 복도에 있다. 이 건물에서 제일 낮은 자리다. 복도 벽 아래쪽에 배기구가 둘 뚫려 있다. 계단 밑에서 저장실 문까지 여덟 걸음.'),
        n('저장실 문 옆에는 노란 함이 하나 붙어 있다. 「공기호흡기」. 공기통을 메고 얼굴을 덮는 마스크로 숨을 쉬는 장비다. 이산화탄소 설비가 있는 건물은 이것을 갖춰 둬야 한다. 함 안에는 한 벌뿐이고, 점검표의 마지막 날짜는 재작년 6월이다.'),
        n('채 과장에게는 행사 동안 옆문 셋을 열어 두자고 했다. 회장 지시라 안 된다는 답을 들었다. 문 넷 옆의 초록색 비상 개방 상자만 하나씩 다시 봐 뒀다. 덮개를 깨고 누르면 그 문을 붙잡은 전자석이 풀린다.'),
        n('문 대장은 잠금핀 사진을 들고 변재만 회장을 찾아가 식을 지상으로 옮기라고 했다.'),
        say('byun', '잠갔으면 됐소. 식은 예정대로 하오. 그리고 홀 안에 경찰은 둘만 들이시오. 손님들이 불안해하오.'),
        n('설비를 잠근 순간, 식을 강제로 막을 근거도 같이 사라졌다.'),
        n('저녁 7시. 컨벤션홀에 천 명이 앉았다. 형사들은 윤시호의 9년 전 증명사진 한 장을 들고 로비와 계단, 1층 현관에 섰다. 저장실 문 앞에 세웠던 형사도 식이 시작되자 로비로 올라왔다. 잠근 설비보다 천 명 사이에 섞여 들 얼굴이 더 급하다는 것이 문 대장의 판단이었다.'),
        n('문 대장은 현관 앞 지휘 차량에서 무전을 잡았다. 홀 안에는 곽 경사와 내가 들어갔다.'),
        n('7시 30분. 기념 영상이 돌아가는 동안 주머니에서 휴대폰이 떨렸다. 화면에 이름이 떠 있었다. 윤은호. 넉 달 동안 꺼져 있던 번호다.'),
        me('…은호 씨.'),
        say('eunho', '지안 씨. 시간이 없어서 할 말만 할게요. 저 지금 한성 본사 지하 3층이에요. 가스 저장실 문 앞이요.'),
        say('eunho', '시호가 저 안에 있어요. 10분 전에 들어가는 걸 봤어요. 주황 조끼를 입고, 카드를 대고 들어갔어요. 이 건물 소방 기사가 시호예요.'),
        say('eunho', '10분을 두드렸는데 대답이 없어요. 저 혼자서는 안 되겠어요.'),
        n('주황 조끼. 방재실 수신기 함 안에 상체를 넣고 일하던 등. 낮에 밸브를 잠근 사람. 나는 그 사람의 얼굴을 한 번도 보지 못했다.'),
        say('eunho', '낮에 잠갔다는 건 믿으면 안 돼요. 잠근 사람이 시호예요.'),
        say('eunho', '7시 42분일 거예요. 119에 첫 신고가 들어간 시각이요. 그때 홀에 경보가 울리고, 30초 뒤에 천장에서 가스가 나와요. 전산센터 때 그 방은 경보가 울리면 문부터 잠기게 돼 있었어요. 걔는 그것도 되살려 놨을 거예요.'),
        say('eunho', '정문 안쪽 커튼 뒤에 조작함이 있어요. 거기 방출 지연 단추를 누르면 30초 시계가 멈춰요. 누르고 있는 동안만요. 손을 떼면 다시 가요. 누가 끝까지 누르고 있어야 해요. 그동안 사람들을 내보내 줘요.'),
        say('eunho', '로비에 세워 두면 안 돼요. 그 방은 벽이 뚫려 있어서 가스가 로비로 새고, 무거워서 계단 밑에 고여요. 지상까지 올려 보내야 해요.'),
        me('지금 내보내면 되잖아요. 12분 남았어요.'),
        say('eunho', '안 돼요. 걔는 안에서 화면으로 홀을 보고 있어요. 사람들이 일어서면 그 순간 수동 레버를 당길 거예요. 레버는 30초도 안 줘요. 단추도 소용없어요.'),
        say('eunho', '레버는 제가 막을게요. 문을 열어 달라고 할 거예요. 제가 들어갈 때까지는 아무도 일으키지 마요. 문을 따려고 사람을 보내지도 마요. 문 건드리는 소리가 나면 걔는 당겨요.'),
        me('내려갈게요. 지금.'),
        say('eunho', '내려오지 마요. 들어가지 말라고 제가 가르쳤잖아요.'),
        n('전화는 끊기지 않았다. 옷감 스치는 소리가 났다. 윤은호는 전화기를 켠 채로 주머니에 넣었다. 나는 이어폰 한쪽을 왼쪽 귀에 꽂고 무전기를 잡았다.'),
        me('대장님. 윤은호한테서 전화 왔습니다. 본사 지하 3층 저장실 문 앞입니다. 윤시호가 저장실 안에 있습니다. 낮에 설비를 잠근 마 기사가 윤시호입니다.'),
        n('연락이 오면 보고하겠다고 했었다. 들은 것을 그대로 옮겼다. 무전기 저쪽이 3초쯤 조용했다.'),
        say('moon', '…알았다. 곽 경사는 지금 조작함 앞으로 가. 커튼 뒤에 서 있다가 경보가 울리면 유리를 깨고 눌러. 그 전에는 손대지 마. 화면에 잡혀.'),
        say('moon', '형사 셋을 손님처럼 들여보낸다. 지하 3층에는 아무도 안 내려보낸다. 119는 불러서 한 블록 밖에 세워 둔다. 서 경위는 귀에 꽂은 거 빼지 마.'),
        n('그 뒤 10분 동안 이어폰에서는 같은 소리가 났다. 쇠문을 두드리는 소리, 그리고 윤은호의 목소리.'),
        say('eunho', '시호야. 형이야. 문 열어.'),
        say('eunho', '시호야. 나 안 가. 네가 열 때까지 여기 있을 거야.'),
        n('대답은 없었다. 7시 40분, 무대에서는 변재만 회장이 잔을 들고 마이크 앞에 섰다.'),
        n('7시 41분. 이어폰에서 빗장 풀리는 소리가 났다. 쇠문이 열렸다.'),
        say('siho', '…형.'),
        n('낮고 차분한 목소리다. 방재실의 수신기 함 안에서 대답하던 그 목소리다.'),
        say('siho', '가. 여기 있으면 안 돼.'),
        say('eunho', '들어간다.'),
        n('발소리가 둘. 쇠문이 닫혔다. 나는 무전기에 대고 말했다. 들어갔습니다.'),
        n('7시 42분. 홀 천장에서 사이렌이 울렸다. 화재 경보와는 다른 소리다. 녹음된 목소리가 뒤따랐다. 「가스가 방출됩니다. 즉시 대피하십시오.」'),
        n('동시에 정문에서 쿵 소리가 났다. 문틀 위의 전자석이 문을 붙잡았다. 문 넷이 전부 잠겼다.'),
        n('정문 옆 커튼이 젖혀졌다. 곽 경사가 조작함의 유리 덮개를 팔꿈치로 쳤다. 금도 가지 않았다. 옛날 판유리다. 함의 작은 창에서는 붉은 숫자가 줄고 있었다. 00:24.'),
        n('곽 경사가 무전기 모서리로 쳤다. 금이 갔다. 00:16. 주먹으로 쳤다. 한 번. 두 번. 세 번째에 깨졌다.'),
        n('곽 경사의 엄지가 노란 단추를 눌렀다. 붉은 숫자가 멈췄다. 00:07.'),
        n('깨진 유리가 곽 경사의 손등을 그었다. 피가 손목으로 흘렀다. 그는 단추에서 엄지를 떼지 않았다.'),
        say('kwak', '눌렀어! 나는 여기서 못 움직여. 서 경위, 사람들!'),
        n('천 명이 웅성거리며 일어서고 있다. 사이렌에 묻힌 녹음 목소리를 알아들은 사람은 아직 많지 않다. 누군가 정문 손잡이를 흔들기 시작했다. 열리지 않는다.'),
        n('무대 위에 사회자의 마이크가 있다. 손님들 사이에 형사 셋이 서 있다. 나머지 형사들은 잠긴 문 바깥, 로비와 계단에 있다.'),
      ],
      options: [
        { id: 'shout', label: '마이크부터 잡는다. 가스가 나온다고, 지금 당장 나가라고 외친다' },
        { id: 'force', label: '형사들과 정문에 달려든다. 잠긴 문부터 힘으로 연다' },
        { id: 'release', label: '문 옆 초록 상자부터 깬다. 문이 열린 다음에 마이크를 잡는다' },
      ],
      accept: ['release'],
      rebuttal: {
        shout: [
          n('나는 무대로 뛰어올라 마이크를 잡고 외쳤다. 천 명이 한꺼번에 정문으로 몰렸다. 그들이 아는 문은 들어온 문 하나뿐이다. 그 문은 잠겨 있었다.'),
          n('앞사람이 문에 눌렸다. 뒷사람은 그것을 모르고 밀었다. 비명이 사이렌을 덮었다.'),
          n('사람의 물결이 정문 옆 조작함 앞을 쓸고 지나갔다. 곽 경사가 벽에서 밀려나는 것을 봤다. 엄지가 단추에서 떨어졌다. 붉은 숫자가 다시 움직였다.'),
        ],
        force: [
          n('형사 셋과 내가 정문에 어깨를 박았다. 문은 꿈쩍도 하지 않았다. 문틀 위의 전자석은 어른 서넛이 매달려도 버틴다.'),
          n('경찰이 문을 부수려는 것을 본 사람들이 겁에 질렸다. 천 명이 그 문으로 몰렸다. 우리는 문과 사람들 사이에 끼었다.'),
          n('사람의 물결이 조작함 앞을 쓸고 지나갔다. 곽 경사의 엄지가 단추에서 떨어졌다. 붉은 숫자가 다시 움직였다.'),
        ],
      },
      success: [
        me('문 옆 초록 상자! 깨고 누르세요! 뒷문, 왼쪽, 오른쪽!'),
        n('형사 셋이 세 방향으로 뛰었다. 나는 정문의 초록 상자를 팔꿈치로 깼다. 단추를 눌렀다. 찰칵. 전자석이 문을 놓았다. 문을 끝까지 밀어 고정했다.'),
        n('잠시 뒤 왼쪽에서, 이어서 뒤쪽과 오른쪽에서 문 열리는 소리가 났다. 문 넷이 다 열렸다.'),
        n('나는 무대로 뛰어올라 마이크를 잡았다. 목소리를 낮췄다.'),
        me('경찰입니다. 설비에 이상이 생겨 건물 밖으로 나가셔야 합니다. 문 네 곳이 모두 열렸습니다. 뛰지 마십시오. 지금 계신 자리에서 가장 가까운 문으로, 앞사람을 따라 걸어 나가십시오.'),
        me('무대 앞 구역은 정문. 왼쪽 구역은 왼쪽 문. 오른쪽 구역은 오른쪽 문. 뒤쪽 구역은 뒷문. 나가시면 로비에 서지 말고 계단으로 지상까지 올라가십시오.'),
        n('사람들이 움직이기 시작했다. 빨랐지만 뛰지는 않았다. 로비의 형사들이 두 계단 앞에 줄을 세웠다.'),
        n('변재만 회장은 경호원 여섯에게 둘러싸여 제일 먼저 정문을 나갔다. 피 흐르는 손으로 단추를 누르고 선 곽 경사를 회장은 쳐다보지도 않았다.'),
      ],
    },
    {
      type: 'choice',
      stage: '결전',
      sudden: 'fallen',
      label: '계단 아래에 두 사람이 있다',
      brief: '저녁 7시 51분, 지하 3층 계단문. 열 단 아래 기계실 복도에 흰 김이 허리 높이로 차 있다. 저장실 문까지 여덟 걸음. 윤은호가 윤시호를 끌고 나오고 있다. 공기통은 윤시호의 얼굴에 있는 하나뿐이다.',
      prompt: [
        n('마이크로 구역을 하나씩 부르는 동안, 왼쪽 귀에서는 지하 3층의 소리가 계속 났다.'),
        say('siho', '형. 거기서 비켜.'),
        say('eunho', '안 비켜.'),
        n('발소리가 두 번 나고 멎었다. 몸이 부딪치는 소리는 나지 않았다.'),
        say('siho', '사람들이 나가.'),
        say('eunho', '응. 내가 전화했어.'),
        n('한참 말이 없었다. 기계 돌아가는 소리만 났다.'),
        say('eunho', '시호야. 4월에 전선에 붙은 숫자 봤어. 네가 붙인 건 줄 알았어. 그날 바로 말했어야 했는데 못 했어. 혼자 찾겠다고 여덟 달을 썼어. 늦었어.'),
        say('eunho', '늦은 건 그때부터가 아니야. 15년 전에 중학교 3학년짜리를 삼촌 집에 두고 나 혼자 서울로 갔어. 그때부터야.'),
        n('윤시호는 그 말에 대답하지 않았다. 한참 뒤에 다른 말을 했다.'),
        say('siho', '나는 다 했어, 형. 꺼 놓은 걸 보면 적었어. 서명해 달라고 했어. 안 해 주면 안 해 줬다고 적고 신고했어. 7년 동안 스물세 번.'),
        say('siho', '평택 창고에도 적어 놨어. 경보 꺼져 있다고. 3주 뒤에 불났어. 스물한 살이었어. 거기서 일한 지 두 달 됐대.'),
        say('eunho', '알아. 네가 쓴 스물세 장, 다 읽었어.'),
        n('윤시호는 대답하지 않았다.'),
        n('7시 50분. 홀에서는 마지막 원탁의 사람들이 뒷문으로 나가고 있었다.'),
        say('siho', '다 나갔네.'),
        say('siho', '형, 나가. 문 안 잠갔어.'),
        say('eunho', '같이 나가자.'),
        say('siho', '나는 안 나가. 처음부터 안 나갈 거였어.'),
        n('쇠 꼭지 돌아가는 소리가 났다. 그리고 바람 소리. 굵은 관에서 공기가 한꺼번에 빠지는 소리다. 하나가 아니었다. 멎지 않았다.'),
        say('eunho', '시호야, 뭐 하는 거야. 잠가!'),
        say('siho', '나가, 형. 빨리.'),
        n('나는 마이크를 내려놓고 무대에서 뛰어내렸다. 남은 사람들은 형사 셋이 문으로 이끌고 있었다.'),
        n('정문 옆 조작함 앞에서 곽 경사와 눈이 마주쳤다. 엄지는 그대로 단추 위에 있었다.'),
        me('저장실 안에서 가스가 터졌어요. 지하 3층으로 가요.'),
        say('kwak', '서 경위! 음성 때처럼 해. 들어가지 마!'),
        n('뛰면서 무전기를 잡았다.'),
        me('대장님. 지하 3층 저장실 안에서 가스가 터졌습니다. 안에 두 사람이 있습니다. 공기통 멘 소방대를 지하 3층으로 내려보내 주세요.'),
        n('지하 3층으로 내려가는 계단에는 아무도 없었다. 이어폰에서는 바람 소리와 기침 소리가 났다.'),
        say('eunho', '시호야. 시호야!'),
        n('대답이 없었다. 윤시호는 벽에 기대어 바닥에 앉아 있었다. 그것은 나중에 안 일이다. 이산화탄소는 바닥부터 찬다. 앉은 사람이 선 사람보다 먼저 정신을 잃는다.'),
        n('쇠문이 벽에 부딪히는 소리. 뛰는 발소리. 얇은 철판 문이 열리는 소리.'),
        n('저장실 문 옆의 노란 함이다. 공기호흡기. 그 건물에 한 벌뿐인 것.'),
        n('다시 발소리. 공기통 꼭지 열리는 소리가 났다.'),
        say('eunho', '시호야. 이거 쓰자. …됐다. 숨 쉬어. 숨 쉬어.'),
        n('윤은호는 그것을 제 얼굴에 쓰지 않았다.'),
        me('은호 씨! 그거 당신이 써요! 당신이 쓰고 끌고 나와요!'),
        n('주머니 속의 전화기는 내 목소리를 윤은호의 귀까지 전하지 못했다.'),
        say('eunho', '열쇠. 열쇠 어디 있어. …여기 있네.'),
        n('쇠붙이가 짤랑거렸다. 몇 걸음. 열쇠 돌아가는 소리.'),
        n('무전기가 울렸다.'),
        say('kwak', '서 경위! 숫자가 꺼졌어. 창이 까매. 사이렌도 멎었어. 손 떼도 돼?'),
        me('떼요. 멈췄어요. 윤은호가 저장실에서 멈췄어요.'),
        n('7시 51분, 지하 3층 계단문. 문 옆 벽에 회색 조작반과 붉은 소화전함이 있다. 그 앞에서 계단 열 단이 기계실 복도로 내려간다.'),
        n('복도에 흰 김이 허리 높이로 차 있다. 계단의 아래 다섯 단이 잠겼다. 저장실 쪽은 뿌옇게 가려 보이지 않는다. 김은 거기서 계속 밀려 나온다.'),
        n('이어폰에서 무거운 것이 바닥에 끌리는 소리가 났다. 기침. 다시 끌리는 소리.'),
        n('저 안에 두 사람이 있다. 윤시호는 공기통으로 숨을 쉬고, 윤은호는 그 복도의 공기를 그대로 마시고 있다. 계단 밑에서 저장실 문까지 여덟 걸음.'),
        n('4월에 윤은호가 일러 준 순서가 있다. 들어가지 말 것. 가스를 잠그고 바람부터 넣을 것. 꼭 들어가야 하면 공기통을 메고, 밖에서 줄을 잡아 줄 사람을 둘 것.'),
      ],
      options: [
        { id: 'run', label: '숨을 참고 뛰어 내려간다. 여덟 걸음이다' },
        { id: 'low', label: '불이 났을 때처럼 몸을 낮추고 내려간다' },
        { id: 'stay', label: '내려가지 않는다. 계단문 문턱에 선다' },
      ],
      accept: ['stay'],
      rebuttal: {
        run: [
          n('숨을 크게 들이마시고 열 단을 뛰어 내려갔다. 다섯 걸음째에 윤은호의 등이 보였다. 팔을 잡으려고 허리를 굽혔다. 얼굴이 김 속으로 들어갔다. 끌어당기는 순간 참았던 숨이 터졌다.'),
          n('들이마신 것은 공기 같지 않았다. 두 번째 숨에 눈앞이 좁아졌다. 윤은호의 팔을 잡은 채로 무릎이 접혔다.'),
        ],
        low: [
          n('불이 났을 때 하던 대로 몸을 낮췄다. 벽을 짚고 계단을 내려갔다.'),
          n('연기는 위로 가지만 이산화탄소는 바닥에 깔린다. 몸을 낮출수록 가스 속으로 들어간다. 다섯 단을 내려갔을 때 눈앞이 하얗게 번졌다.'),
        ],
      },
      success: [
        n('발이 계단으로 가려는 것을 붙잡았다. 문턱에서 한 단도 내려가지 않았다.'),
        n('내가 저 밑에서 쓰러지면 윤은호가 끌어야 할 사람이 둘이 된다.'),
        me('은호 씨! 계단문에 있어요! 안 내려가요! 소리 나는 쪽으로 와요!'),
      ],
    },
    {
      type: 'choice',
      stage: '결전',
      sudden: 'short',
      label: '무엇부터 할 것인가',
      brief: '계단문 옆 벽에 회색 조작반과 붉은 소화전함이 있다. 조작반의 단추는 둘. 「주차장·기계실 배기팬」, 「경사로 셔터」. 소화전함에는 호스가 말려 있다.',
      prompt: [
        n('홀로 가는 가스는 윤은호가 열쇠로 멈췄다. 하지만 저장실 안에서 터진 가스는 복도에 그대로 깔려 있고, 아직도 문으로 밀려 나온다.'),
        n('무전기에서 문 대장이 답했다. 소방대는 1층 현관에서 올라오는 사람들을 받고 있다. 지하로 내려보내려 해도 계단 둘이 사람으로 막혀 있다. 주차장 경사로는 셔터가 내려져 있다.'),
        n('김 속에서 끌리는 소리가 조금씩 느려지고 있다.'),
      ],
      options: [
        { id: 'hose', label: '소화전함을 열고 호스부터 내려보낸다' },
        { id: 'fan', label: '배기팬을 켜고 경사로 셔터를 올린다' },
        { id: 'wait', label: '가스가 올라오지 못하게 계단문을 닫고 소방대를 기다린다' },
      ],
      accept: ['fan'],
      rebuttal: {
        hose: [
          n('소화전함을 열고 호스를 풀었다. 한쪽을 난간에 묶고 다른 쪽을 계단 아래로 던지는 데 30초가 걸렸다.'),
          n('호스 끝은 흰 김 속으로 들어가 보이지 않았다. 끌리는 소리가 가까워지다가 멎었다. 호스는 당겨지지 않았다.'),
          n('배기팬 단추에 손이 간 것은 그다음이었다. 팬이 복도의 가스를 걷어 내는 데는 시간이 걸린다. 그 시간이 윤은호에게는 없었다.'),
        ],
        wait: [
          n('가스가 계단으로 올라오지 못하게 문을 닫았다. 문에 등을 대고 무전기로 소방대를 불렀다.'),
          n('소방대는 내려오는 길을 찾지 못했다. 계단은 사람으로 막혀 있었고, 경사로는 셔터가 내려져 있었다. 이어폰에서 끌리는 소리가 멎었다.'),
        ],
      },
      success: [
        n('「배기팬」 단추를 눌렀다. 천장 속에서 큰 날개가 돌기 시작했다. 복도 벽 아래쪽 배기구로 흰 김이 빨려 들어갔다.'),
        n('「경사로 셔터」를 올림 쪽으로 눌렀다. 주차장 저쪽 끝에서 쇠 셔터가 감겨 올라가는 소리가 났다. 찬 바깥 공기가 경사로를 타고 내려와 내 등을 밀었다.'),
        me('대장님. 지하 3층 경사로 셔터 올렸습니다. 소방대하고 구급대를 경사로로 내려보내 주세요. 공기통 메고요.'),
        say('moon', '보냈다. 4분.'),
        n('계단 다섯째 단이 김 밖으로 드러났다. 넷째 단. 셋째 단.'),
      ],
    },
    {
      type: 'choice',
      stage: '결전',
      sudden: 'fallen',
      label: '어떻게 끌어낼 것인가',
      brief: '배기팬이 돌고 있다. 복도의 흰 김이 발목 높이로 가라앉았다. 계단 밑 네 걸음 앞에 윤은호가 무릎을 꿇고 있다. 소화전함에는 호스가 말려 있다.',
      prompt: [
        n('김이 가라앉자 복도 안이 보였다. 윤은호가 뒷걸음으로 나오고 있다. 두 팔을 윤시호의 겨드랑이에 끼고 끈다. 윤시호의 얼굴에는 마스크가 씌워져 있고, 공기통이 바닥에 끌린다.'),
        n('윤은호가 한쪽 무릎을 꿇었다. 일어났다. 두 걸음을 더 왔다. 다시 꿇었다. 이번에는 일어나지 못한다. 계단 밑까지 네 걸음이다.'),
        n('흰 김은 이제 발목 높이다. 하지만 김은 가스가 아니다. 가스가 차가워서 생긴 물안개일 뿐이고, 이산화탄소는 눈에 보이지 않는다. 김이 걷혔다고 가스가 걷힌 것은 아니다.'),
        n('소방대는 아직 경사로 위에 있다.'),
      ],
      options: [
        { id: 'down', label: '김이 걷혔다. 지금 내려가 같이 끈다. 네 걸음이다' },
        { id: 'cloth', label: '젖은 손수건으로 코와 입을 막고 내려간다' },
        { id: 'line', label: '내려가지 않는다. 소화전 호스를 풀어 줄로 내려보낸다' },
      ],
      accept: ['line'],
      rebuttal: {
        down: [
          n('네 걸음이다. 김도 걷혔다. 계단을 뛰어 내려가 윤은호의 겨드랑이에 팔을 넣었다.'),
          n('일으키려고 힘을 주는 순간 숨이 찼다. 들이마셨다. 김이 걷힌 자리에 가스는 그대로 있었다. 윤은호의 손이 내 팔을 밀어내려다 떨어졌다.'),
        ],
        cloth: [
          n('손수건에 생수를 부어 코와 입을 막고 내려갔다.'),
          n('젖은 천은 연기를 조금 거를 뿐이다. 없는 산소를 만들어 주지는 못한다. 봄에 방진 마스크 얘기를 하며 윤은호가 한 말이다. 계단을 다 내려가기도 전에 다리가 풀렸다.'),
        ],
      },
      success: [
        n('소화전함을 열고 말린 호스를 통째로 꺼냈다. 한쪽 끝을 계단 난간 기둥에 두 번 감아 묶었다.'),
        n('쇠 주둥이가 달린 다른 쪽 끝을 계단 아래로 힘껏 던졌다. 호스가 풀리며 열 단을 굴러 내려가 복도 바닥을 미끄러졌다. 윤은호의 무릎 옆에서 멈췄다.'),
        me('은호 씨! 오른쪽에 호스! 잡아요! 팔에 감아요!'),
        n('윤은호가 고개를 돌렸다. 손을 뻗어 호스를 잡았다. 팔뚝에 한 번 감았다. 다른 팔은 윤시호의 가슴을 안은 채 풀지 않았다.'),
        n('나는 문턱에 발을 걸고 호스를 당겼다. 두 사람의 무게가 실려 왔다. 한 뼘. 또 한 뼘.'),
        n('등 뒤 계단에서 발소리가 났다. 곽 경사다. 손수건을 감은 손으로 내 뒤에서 호스를 잡았다.'),
        say('kwak', '하나, 둘, 당겨!'),
      ],
    },
  ],
};

export const ENDINGS = {
  true: {
    title: '임계',
    lines: [
      n('윤은호는 호스에 매달려 계단을 올라왔다. 한 단, 또 한 단. 윤시호의 공기통이 단마다 부딪혀 소리를 냈다.'),
      n('아홉째 단까지 올라왔을 때 내 손이 윤은호의 옷깃에 닿았다. 곽 경사가 윤시호를 받아 올렸다.'),
      n('윤은호는 계단문 문턱을 넘어와 쓰러졌다. 저장실 문에서 여기까지 2분이 걸리지 않았다.'),
      n('나는 윤은호의 머리를 무릎에 받쳤다. 입술이 파랬다. 여덟 달 만에 보는 얼굴이다. 뺨이 패어 있었다.'),
      say('eunho', '지안 씨… 왔네요.'),
      me('왔어요. 늦었죠.'),
      say('eunho', '아니요. 저도 늦었으니까.'),
      n('윤은호가 고개를 옆으로 돌렸다. 곽 경사가 눕혀 놓은 윤시호의 마스크 안쪽이 숨에 맞춰 흐려졌다가 맑아졌다. 윤은호는 그것을 한 번 봤다.'),
      n('그러고는 눈을 감았다. 숨이 얕아졌다. 멎었다.'),
      n('나는 윤은호의 가슴을 눌렀다. 구급대가 경사로를 뛰어 내려올 때까지 눌렀다.'),
      n('윤은호는 깨어나지 않았다.'),
      n('천 명 가운데 다친 사람은 열한 명이다. 전부 계단에서 발을 삔 사람들이다. 곽 경사는 손등을 여덟 바늘 꿰맸다.'),
      n('저장실 벽 쪽에 따로 서 있던 예비 가스통 둘은 꼭지가 열린 채 비어 있었다. 제어반의 열쇠는 「정지」로 돌아가 있었다. 수동 레버는 당겨지지 않았다.'),
      n('윤시호는 이튿날 병원에서 눈을 떴다. 봄에 음성의 공장 정문에서 차창 너머로 본 눈이다. 처음 한 말은 하나였다.'),
      say('siho', '형은요.'),
      me('돌아가셨습니다. 그날 밤, 당신을 계단 위까지 끌고 올라와서요.'),
      n('윤시호는 천장을 봤다. 한참 뒤에 입을 열었다. 홍천부터였다. 홍천, 화성, 부산, 음성, 그리고 본사 지하. 묻지 않은 것까지 말했다. 조서를 받는 데 사흘이 걸렸다.'),
      n('이듬해 3월, 재판이 하나 더 열렸다. 본사 지하에 그 설비가 왜 남아 있었는지, 옆문이 왜 잠겨 있었는지, 한 벌뿐인 공기호흡기가 왜 2년 동안 점검되지 않았는지를 묻는 재판이다. 관리자 서명 칸이 빈 9월의 점검표가 증거로 나왔다. 피고인석에는 변재만이 앉았다.'),
      n('4월의 토요일 밤, 서해과학관 옥상에 올라갔다. 혼자였다.'),
      n('차례를 기다려 망원경에 눈을 댔다. 목성을 봤다.'),
    ],
    epilogue: '윤시호는 살인 네 건과 천 명에 대한 살인미수로 재판을 받는다. 한성 창립 기념식의 천 명은 걸어서 지상으로 올라왔다. 윤은호는 동생을 계단 위까지 끌고 올라왔다.',
  },
  bad: {
    title: '12월 11일',
    lines: [
      n('말이 꼬였다. 문 대장이 시계를 봤다.'),
      say('moon', '5분 지났어. 배치는 그대로 간다.'),
      n('오전, 예순 명이 인천에 섰다. 준공식은 아무 일 없이 끝났다. 수사본부는 「경비 강화로 범행을 막았음」이라고 적었다.'),
      n('저녁, 같은 예순 명이 한성 본사의 회장 둘레와 출입구에 섰다. 전부 한 사람의 얼굴을 찾았다. 천장을 올려다본 사람은 없었다.'),
      n('7시 42분, 무전기가 한꺼번에 울리기 시작했다. 한성 본사 지하였다.'),
      n('문은 넷 다 잠겨 있었다고 했다.'),
    ],
    epilogue: '가장 그럴듯한 그림이 예순 명에게 엉뚱한 것을 찾게 했다. 하지만 단서는 아직 당신의 수첩에 남아 있다.',
    retry: 'deduce',
  },
  disaster: {
    title: '대참사',
    lines: [
      n('7초 뒤, 천장의 분사구 스물네 개가 한꺼번에 소리를 냈다.'),
      n('그날 밤 한성 본사 지하에서 일어난 일은 이튿날 모든 신문의 1면에 실렸다. 기사 첫 줄에는 숫자가 있었다.'),
      n('15년 전에는 아홉 명이었다. 그때도 장치는 꺼져 있었고, 문은 잠겨 있었고, 서류에는 전부 정상이라고 적혀 있었다.'),
    ],
    epilogue: '잠긴 문 앞으로 천 명을 몰아서는 안 된다. 문 넷을 먼저 열고, 구역을 나눠 걸어서 내보낸다. 결전 장면부터 다시 할 수 있다.',
    retry: 'confront',
  },
  fallen: {
    title: '계단 아래',
    lines: [
      n('그날 밤의 기억은 거기서 끊긴다.'),
      n('눈을 떴을 때는 병원이었다. 나를 끌어내려고 따라 내려온 곽 경사가 옆 침대에 누워 있었다.'),
      n('윤시호는 마스크를 쓴 채 살아서 나왔다. 윤은호는 그 복도에서 나오지 못했다.'),
    ],
    epilogue: '구하러 들어간 사람이 구조될 사람이 됐다. 들어가지 말 것. 바람부터 넣을 것. 공기통이 없으면 내려가지 않고 줄을 내려보낸다. 결전 장면부터 다시 할 수 있다.',
    retry: 'confront',
  },
  short: {
    title: '여덟 걸음',
    lines: [
      n('소방대가 공기통을 메고 그 복도에 들어간 것은 7분 뒤였다.'),
      n('윤시호는 마스크를 쓴 채 숨을 쉬고 있었다. 윤은호는 윤시호의 겨드랑이에 두 팔을 낀 채 엎드려 있었다. 저장실 문에서 세 걸음 나온 자리였다.'),
    ],
    epilogue: '홀로 가는 가스는 윤은호가 멈췄다. 남은 것은 바람이었다. 배기팬과 경사로 셔터의 단추는 계단문 바로 옆에 있었다. 결전 장면부터 다시 할 수 있다.',
    retry: 'confront',
  },
};
